import styled, { css } from 'styled-components';

export const DoubleArrowIcon = ({ fill = '#8a8a8a' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-arrows-diagonal"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M16 4l4 0l0 4" />
      <path d="M14 10l6 -6" />
      <path d="M8 20l-4 0l0 -4" />
      <path d="M4 20l6 -6" />
    </svg>
  );
};

export const ConnectLevelsIcon = ({ isLevelMandatory }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="16"
      height="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="6"
        y1="12"
        x2="18"
        y2="12"
        stroke={isLevelMandatory ? '#416ab5' : 'gray'}
        strokeWidth="2"
        strokeLinecap="round"
      />

      <circle
        cx="6"
        cy="12"
        r="4"
        fill={isLevelMandatory ? '#416ab5' : '#333333'}
      />

      <circle
        cx="18"
        cy="12"
        r="4"
        fill={isLevelMandatory ? '#416ab5' : '#333333'}
      />
    </svg>
  );
};

export const ArrangeIcon = ({ size = 10, color = '#5786CC' }) => {
  return (
    <svg
      className="arrange-icon"
      width={size}
      height={size}
      viewBox="0 0 14 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0"
        y="0"
        width="8"
        height="2"
        rx="1"
        fill={color}
        opacity="0.9"
      />
      <rect
        x="2"
        y="5"
        width="8"
        height="2"
        rx="1"
        fill={color}
        opacity="0.9"
      />
      <rect
        x="4"
        y="10"
        width="8"
        height="2"
        rx="1"
        fill={color}
        opacity="0.9"
      />
    </svg>
  );
};

export const ConnectorIcon = ({ size = 24, color = '#141E46' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="3"
        width="6"
        height="6"
        rx="1"
        stroke={color}
        strokeWidth="2"
      />
      <rect
        x="15"
        y="15"
        width="6"
        height="6"
        rx="1"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M9 6L15 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13 16L15 18L17 16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseIcon = ({ fill = '#8A8A8A' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_11)">
        <path
          d="M19.7143 4.28572L4.28571 19.7143M4.28571 4.28572L19.7143 19.7143"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_11">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MaximizeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
  </svg>
);

export const MinimizeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3" />
  </svg>
);

export const CollapseIcon = ({ fill }) => {
  return (
    <svg
      width="7"
      height="14"
      viewBox="0 0 7 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.20353 3.99484L3.50868 1.68969L5.81383 3.99484C5.94585 4.12235 6.12267 4.19291 6.30622 4.19131C6.48976 4.18972 6.66533 4.1161 6.79512 3.98631C6.92491 3.85652 6.99853 3.68095 7.00012 3.49741C7.00172 3.31386 6.93116 3.13704 6.80365 3.00501L4.00359 0.204955C3.87231 0.0737223 3.6943 0 3.50868 0C3.32306 0 3.14504 0.0737223 3.01377 0.204955L0.213706 3.00501C0.146848 3.06959 0.0935191 3.14683 0.056832 3.23224C0.0201449 3.31764 0.000834119 3.4095 2.64305e-05 3.50244C-0.000781258 3.59539 0.0169302 3.68757 0.0521275 3.7736C0.0873249 3.85963 0.139303 3.93779 0.205029 4.00351C0.270756 4.06924 0.348914 4.12122 0.434943 4.15641C0.520972 4.19161 0.61315 4.20932 0.706098 4.20852C0.799045 4.20771 0.890901 4.1884 0.976306 4.15171C1.06171 4.11502 1.13895 4.06169 1.20353 3.99484V3.99484ZM0.213706 10.995L3.01377 13.795C3.14504 13.9263 3.32306 14 3.50868 14C3.6943 14 3.87231 13.9263 4.00359 13.795L6.80365 10.995C6.93116 10.863 7.00172 10.6861 7.00012 10.5026C6.99853 10.3191 6.92491 10.1435 6.79512 10.0137C6.66533 9.8839 6.48976 9.81028 6.30622 9.80869C6.12267 9.80709 5.94585 9.87765 5.81383 10.0052L3.50868 12.3103L1.20353 10.0052C1.13895 9.93831 1.06171 9.88498 0.976306 9.84829C0.890901 9.8116 0.799045 9.79229 0.706098 9.79148C0.61315 9.79068 0.520972 9.80839 0.434943 9.84359C0.348914 9.87878 0.270756 9.93076 0.205029 9.99649C0.139303 10.0622 0.0873249 10.1404 0.0521275 10.2264C0.0169302 10.3124 -0.000781258 10.4046 2.64305e-05 10.4976C0.000834119 10.5905 0.0201449 10.6824 0.056832 10.7678C0.0935191 10.8532 0.146848 10.9304 0.213706 10.995V10.995Z"
        fill={fill || 'black'}
      />
    </svg>
  );
};

export const LanguageIcon = ({ fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_211_62)">
        <path
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.35 18.92 8ZM12 4.04C12.83 5.24 13.48 6.57 13.91 8H10.09C10.52 6.57 11.17 5.24 12 4.04ZM4.26 14C4.1 13.36 4 12.69 4 12C4 11.31 4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12C7.5 12.68 7.56 13.34 7.64 14H4.26ZM5.08 16H8.03C8.35 17.25 8.81 18.45 9.41 19.56C7.57 18.93 6.04 17.66 5.08 16ZM8.03 8H5.08C6.04 6.34 7.57 5.07 9.41 4.44C8.81 5.55 8.35 6.75 8.03 8ZM12 19.96C11.17 18.76 10.52 17.43 10.09 16H13.91C13.48 17.43 12.83 18.76 12 19.96ZM14.34 14H9.66C9.57 13.34 9.5 12.68 9.5 12C9.5 11.32 9.57 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.68 14.43 13.34 14.34 14ZM14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.96 17.65 16.43 18.93 14.59 19.56ZM16.36 14C16.44 13.34 16.5 12.68 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.69 19.9 13.36 19.74 14H16.36Z"
          fill={fill || '#C6C6C6'}
        />
      </g>
      <defs>
        <clipPath id="clip0_211_62">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Checked = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.183 7.37319C14.183 7.18569 14.1227 7.03167 14.0022 6.91113L13.0881 6.00711C12.9609 5.87988 12.8102 5.81627 12.6361 5.81627C12.462 5.81627 12.3113 5.87988 12.1841 6.00711L8.08587 10.0953L5.81578 7.8252C5.68855 7.69796 5.53788 7.63435 5.36377 7.63435C5.18966 7.63435 5.03899 7.69796 4.91176 7.8252L3.9977 8.72921C3.87716 8.84975 3.81689 9.00377 3.81689 9.19127C3.81689 9.37207 3.87716 9.52274 3.9977 9.64328L7.63386 13.2794C7.76109 13.4067 7.91176 13.4703 8.08587 13.4703C8.26667 13.4703 8.42069 13.4067 8.54792 13.2794L14.0022 7.8252C14.1227 7.70466 14.183 7.55399 14.183 7.37319ZM16.7142 9.00042C16.7142 10.4 16.3693 11.6907 15.6796 12.8726C14.9899 14.0545 14.0541 14.9904 12.8721 15.6801C11.6902 16.3698 10.3995 16.7147 8.99993 16.7147C7.60038 16.7147 6.30964 16.3698 5.12772 15.6801C3.9458 14.9904 3.00997 14.0545 2.32024 12.8726C1.63051 11.6907 1.28564 10.4 1.28564 9.00042C1.28564 7.60086 1.63051 6.31013 2.32024 5.12821C3.00997 3.94629 3.9458 3.01046 5.12772 2.32073C6.30964 1.631 7.60038 1.28613 8.99993 1.28613C10.3995 1.28613 11.6902 1.631 12.8721 2.32073C14.0541 3.01046 14.9899 3.94629 15.6796 5.12821C16.3693 6.31013 16.7142 7.60086 16.7142 9.00042Z"
        fill="#313131"
      />
    </svg>
  );
};

export const DefaultUserIcon = () => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9648 12.8446C15.5191 12.8446 18.3695 9.95894 18.3695 6.43988C18.3695 2.92082 15.5191 0 11.9648 0C8.41056 0 5.56012 2.88563 5.56012 6.40469C5.56012 9.92375 8.41056 12.8446 11.9648 12.8446V12.8446ZM11.9648 1.68915C14.5689 1.68915 16.6804 3.80059 16.6804 6.40469C16.6804 9.0088 14.5689 11.1202 11.9648 11.1202C9.3607 11.1202 7.24927 9.04399 7.24927 6.43988C7.24927 3.83578 9.3607 1.68915 11.9648 1.68915V1.68915ZM0.844575 22.8739H23.1554C23.6129 22.8739 24 22.4868 24 22.0293C24 17.5953 20.3754 13.9707 15.9414 13.9707H8.05865C3.62463 13.9707 0 17.5953 0 22.0293C0 22.4868 0.387097 22.8739 0.844575 22.8739V22.8739ZM8.05865 15.6598H15.9414C19.1789 15.6598 21.8182 18.0528 22.2405 21.1848H1.75953C2.18182 18.0528 4.82111 15.6598 8.05865 15.6598Z"
        // fill="#8A8A8A"
        fill="#8A8A8A"
      />
    </svg>
  );
};
export const DefaultUserIconSmall = ({ fill = 'white' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.97654 8.56305C10.346 8.56305 12.2463 6.6393 12.2463 4.29326C12.2463 1.94721 10.346 0 7.97654 0C5.60704 0 3.70675 1.92375 3.70675 4.2698C3.70675 6.61584 5.60704 8.56305 7.97654 8.56305V8.56305ZM7.97654 1.1261C9.71261 1.1261 11.1202 2.53372 11.1202 4.2698C11.1202 6.00587 9.71261 7.41349 7.97654 7.41349C6.24047 7.41349 4.83284 6.02933 4.83284 4.29326C4.83284 2.55718 6.24047 1.1261 7.97654 1.1261V1.1261ZM0.56305 15.2493H15.437C15.7419 15.2493 16 14.9912 16 14.6862C16 11.7302 13.5836 9.31378 10.6276 9.31378H5.37243C2.41642 9.31378 0 11.7302 0 14.6862C0 14.9912 0.258064 15.2493 0.56305 15.2493V15.2493ZM5.37243 10.4399H10.6276C12.7859 10.4399 14.5455 12.0352 14.827 14.1232H1.17302C1.45455 12.0352 3.21408 10.4399 5.37243 10.4399Z"
        fill={fill}
      />
    </svg>
  );
};

export const SignOutIcon = ({ fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9 10.6C21.8 10.5 21.8 10.4 21.7 10.3L19.7 8.3C19.3 7.9 18.7 7.9 18.3 8.3C17.9 8.7 17.9 9.3 18.3 9.7L18.6 10H16C15.4 10 15 10.4 15 11C15 11.6 15.4 12 16 12H18.6L18.3 12.3C17.9 12.7 17.9 13.3 18.3 13.7C18.5 13.9 18.8 14 19 14C19.2 14 19.5 13.9 19.7 13.7L21.7 11.7C21.8 11.6 21.9 11.5 21.9 11.4C22 11.1 22 10.9 21.9 10.6Z"
        fill={fill || '#808080'}
      />
      <path
        d="M17 14C16.4 14 16 14.4 16 15V16C16 16.6 15.6 17 15 17H14V8.4C14 7.1 13.2 6 12.1 5.6L10.5 5H15C15.6 5 16 5.4 16 6V7C16 7.6 16.4 8 17 8C17.6 8 18 7.6 18 7V6C18 4.3 16.7 3 15 3H5C4.9 3 4.8 3 4.7 3.1C4.6 3.1 4.5 3.2 4.5 3.2L4.4 3.3C4.3 3.3 4.2 3.4 4.2 3.5V3.6C4.1 3.6 4 3.7 4 3.8V18C4 18.4 4.3 18.8 4.6 18.9L11.2 21.4C11.4 21.5 11.7 21.5 11.9 21.5C12.3 21.5 12.7 21.4 13 21.1C13.5 20.7 13.9 20.1 13.9 19.5V19H14.9C16.6 19 17.9 17.7 17.9 16V15C18 14.5 17.6 14 17 14ZM6 17.3V5.4L11.3 7.4C11.7 7.6 12 8 12 8.4V19.5L6 17.3Z"
        fill={fill || '#808080'}
      />
    </svg>
  );
};

export const SunIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 21C18.3137 21 21 18.3137 21 15C21 11.6863 18.3137 9 15 9C11.6863 9 9 11.6863 9 15C9 18.3137 11.6863 21 15 21Z"
        fill="white"
      />
      <path
        d="M15 6C14.7348 6 14.4804 5.89464 14.2929 5.70711C14.1054 5.51957 14 5.26522 14 5V3C14 2.73478 14.1054 2.48043 14.2929 2.29289C14.4804 2.10536 14.7348 2 15 2C15.2652 2 15.5196 2.10536 15.7071 2.29289C15.8946 2.48043 16 2.73478 16 3V5C16 5.26522 15.8946 5.51957 15.7071 5.70711C15.5196 5.89464 15.2652 6 15 6ZM15 28C14.7348 28 14.4804 27.8946 14.2929 27.7071C14.1054 27.5196 14 27.2652 14 27V25C14 24.7348 14.1054 24.4804 14.2929 24.2929C14.4804 24.1054 14.7348 24 15 24C15.2652 24 15.5196 24.1054 15.7071 24.2929C15.8946 24.4804 16 24.7348 16 25V27C16 27.2652 15.8946 27.5196 15.7071 27.7071C15.5196 27.8946 15.2652 28 15 28ZM5 16H3C2.73478 16 2.48043 15.8946 2.29289 15.7071C2.10536 15.5196 2 15.2652 2 15C2 14.7348 2.10536 14.4804 2.29289 14.2929C2.48043 14.1054 2.73478 14 3 14H5C5.26522 14 5.51957 14.1054 5.70711 14.2929C5.89464 14.4804 6 14.7348 6 15C6 15.2652 5.89464 15.5196 5.70711 15.7071C5.51957 15.8946 5.26522 16 5 16ZM27 16H25C24.7348 16 24.4804 15.8946 24.2929 15.7071C24.1054 15.5196 24 15.2652 24 15C24 14.7348 24.1054 14.4804 24.2929 14.2929C24.4804 14.1054 24.7348 14 25 14H27C27.2652 14 27.5196 14.1054 27.7071 14.2929C27.8946 14.4804 28 14.7348 28 15C28 15.2652 27.8946 15.5196 27.7071 15.7071C27.5196 15.8946 27.2652 16 27 16ZM6.51 24.49C6.24623 24.4862 5.99463 24.3784 5.81 24.19C5.62375 24.0026 5.51921 23.7492 5.51921 23.485C5.51921 23.2208 5.62375 22.9674 5.81 22.78L7.22 21.36C7.4083 21.1717 7.6637 21.0659 7.93 21.0659C8.1963 21.0659 8.4517 21.1717 8.64 21.36C8.8283 21.5483 8.93409 21.8037 8.93409 22.07C8.93409 22.3363 8.8283 22.5917 8.64 22.78L7.22 24.19C7.12739 24.2845 7.01694 24.3597 6.89507 24.4112C6.77319 24.4627 6.64231 24.4895 6.51 24.49ZM22.07 8.93C21.9384 8.93076 21.8079 8.90554 21.6861 8.85577C21.5643 8.80601 21.4534 8.73268 21.36 8.64C21.2663 8.54704 21.1919 8.43644 21.1411 8.31458C21.0903 8.19272 21.0642 8.06201 21.0642 7.93C21.0642 7.79799 21.0903 7.66728 21.1411 7.54542C21.1919 7.42356 21.2663 7.31296 21.36 7.22L22.78 5.81C22.9713 5.64617 23.2174 5.56057 23.4691 5.57029C23.7207 5.58001 23.9595 5.68434 24.1376 5.86244C24.3157 6.04053 24.42 6.27927 24.4297 6.53095C24.4394 6.78262 24.3538 7.0287 24.19 7.22L22.78 8.64C22.6866 8.73268 22.5757 8.80601 22.4539 8.85577C22.3321 8.90554 22.2016 8.93076 22.07 8.93ZM23.49 24.49C23.3577 24.4895 23.2268 24.4627 23.1049 24.4112C22.9831 24.3597 22.8726 24.2845 22.78 24.19L21.36 22.78C21.2668 22.6868 21.1928 22.5761 21.1423 22.4542C21.0919 22.3324 21.0659 22.2019 21.0659 22.07C21.0659 21.9381 21.0919 21.8076 21.1423 21.6858C21.1928 21.5639 21.2668 21.4532 21.36 21.36C21.4532 21.2668 21.5639 21.1928 21.6858 21.1423C21.8076 21.0919 21.9381 21.0659 22.07 21.0659C22.2019 21.0659 22.3324 21.0919 22.4542 21.1423C22.5761 21.1928 22.6868 21.2668 22.78 21.36L24.19 22.78C24.3763 22.9674 24.4808 23.2208 24.4808 23.485C24.4808 23.7492 24.3763 24.0026 24.19 24.19C24.0054 24.3784 23.7538 24.4862 23.49 24.49ZM7.93 8.93C7.79839 8.93076 7.66793 8.90554 7.54609 8.85577C7.42426 8.80601 7.31344 8.73268 7.22 8.64L5.81 7.22C5.64617 7.0287 5.56057 6.78262 5.57029 6.53095C5.58001 6.27927 5.68434 6.04053 5.86244 5.86244C6.04053 5.68434 6.27927 5.58001 6.53095 5.57029C6.78262 5.56057 7.0287 5.64617 7.22 5.81L8.64 7.22C8.73373 7.31296 8.80812 7.42356 8.85889 7.54542C8.90966 7.66728 8.9358 7.79799 8.9358 7.93C8.9358 8.06201 8.90966 8.19272 8.85889 8.31458C8.80812 8.43644 8.73373 8.54704 8.64 8.64C8.54656 8.73268 8.43574 8.80601 8.31391 8.85577C8.19207 8.90554 8.06161 8.93076 7.93 8.93Z"
        fill="white"
      />
    </svg>
  );
};

export const MoonIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5205 27.1549C18.5975 27.1515 21.5633 26.0036 23.8408 23.9346C23.5736 23.9346 23.3064 23.9346 23.0393 23.9346C20.5913 23.9321 18.1919 23.2505 16.1082 21.9658C14.0244 20.6811 12.3378 18.8435 11.236 16.6574C10.1343 14.4714 9.66049 12.0226 9.8674 9.58333C10.0743 7.1441 10.9538 4.81006 12.408 2.84082C9.50374 3.60142 6.97574 5.39338 5.29631 7.88192C3.61688 10.3704 2.90093 13.3853 3.28221 16.3632C3.66349 19.3411 5.11593 22.0783 7.36815 24.0635C9.62037 26.0486 12.5183 27.1458 15.5205 27.1502V27.1549Z"
        fill="white"
      />
      <path
        d="M18.8482 6.71289C18.7969 6.70317 18.7484 6.68214 18.7063 6.65132C18.6641 6.62051 18.6293 6.5807 18.6045 6.53477L17.7842 5.04883L16.9686 6.53477C16.9437 6.5807 16.9089 6.62051 16.8668 6.65132C16.8246 6.68214 16.7761 6.70317 16.7248 6.71289L15.0607 7.03164L16.2186 8.26914C16.2552 8.3063 16.2828 8.35147 16.2991 8.40108C16.3153 8.4507 16.3199 8.50341 16.3123 8.55508L16.1014 10.2332L17.6342 9.51602C17.6808 9.49289 17.7321 9.48085 17.7842 9.48085C17.8362 9.48085 17.8876 9.49289 17.9342 9.51602L19.4717 10.2332L19.2607 8.55508C19.2533 8.50379 19.2574 8.45148 19.2728 8.402C19.2882 8.35252 19.3145 8.30712 19.3498 8.26914L20.5123 7.03164L18.8482 6.71289ZM26.1279 13.6176L25.992 12.5301C25.9851 12.4784 25.99 12.4259 26.0062 12.3764C26.0225 12.3269 26.0496 12.2817 26.0857 12.2441L26.8311 11.4473L25.7576 11.2504C25.7066 11.2398 25.6585 11.2184 25.6165 11.1877C25.5745 11.1569 25.5395 11.1176 25.5139 11.0723L24.9889 10.1348L24.4592 11.0723C24.4351 11.1179 24.4011 11.1575 24.3598 11.1883C24.3184 11.2191 24.2707 11.2403 24.2201 11.2504L23.1467 11.452L23.9061 12.2441C23.9413 12.2823 23.968 12.3275 23.9841 12.3769C24.0003 12.4262 24.0057 12.4785 23.9998 12.5301L23.8639 13.6176L24.8529 13.1488C24.9 13.1273 24.9512 13.1162 25.0029 13.1162C25.0547 13.1162 25.1058 13.1273 25.1529 13.1488L26.1279 13.6176ZM17.0154 16.5285C17.0504 16.5667 17.0765 16.6121 17.0919 16.6615C17.1073 16.711 17.1116 16.7632 17.1045 16.8145L16.9686 17.8973L17.9576 17.4285C18.0045 17.4065 18.0558 17.3953 18.1076 17.3957C18.1595 17.3948 18.2109 17.406 18.2576 17.4285L19.2467 17.8973L19.1107 16.8145C19.1046 16.7628 19.1097 16.7105 19.1259 16.6611C19.1421 16.6117 19.1689 16.5664 19.2045 16.5285L19.9545 15.7316L18.8811 15.5254C18.8303 15.5159 18.7822 15.4954 18.7401 15.4655C18.698 15.4355 18.6629 15.3968 18.6373 15.352L18.1076 14.391L17.5826 15.352C17.557 15.3968 17.5219 15.4355 17.4798 15.4655C17.4377 15.4954 17.3896 15.5159 17.3389 15.5254L16.2654 15.7316L17.0154 16.5285Z"
        fill="white"
      />
    </svg>
  );
};

export const GearIcon = ({ fill }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.3954 15.0027C24.3954 13.7715 25.1655 12.7206 26.25 12.3037C25.9676 11.1215 25.4996 9.99148 24.8634 8.95576C24.493 9.12028 24.0921 9.2052 23.6868 9.20502C22.9472 9.20502 22.208 8.92312 21.6435 8.35881C20.7727 7.48793 20.5743 6.19986 21.0471 5.13791C20.0116 4.50128 18.8818 4.03283 17.6996 3.75C17.2835 4.83568 16.2321 5.60684 15 5.60684C13.7681 5.60684 12.7167 4.83568 12.3004 3.75C11.1183 4.03283 9.98847 4.5013 8.95307 5.13797C9.4258 6.1998 9.22746 7.48781 8.35652 8.35887C7.79221 8.92318 7.05281 9.20514 6.3133 9.20514C5.90793 9.2053 5.50704 9.12036 5.13656 8.95582C4.50036 9.99151 4.03236 11.1215 3.75 12.3037C4.83451 12.7205 5.60461 13.7715 5.60461 15.0027C5.60461 16.2336 4.83516 17.2841 3.75129 17.7012C4.03426 18.8833 4.50281 20.0131 5.13949 21.0485C5.50915 20.8848 5.90897 20.8004 6.31324 20.8005C7.05281 20.8005 7.79209 21.0825 8.35647 21.6468C9.22605 22.5164 9.42516 23.802 8.955 24.863C9.99051 25.4993 11.1203 25.9675 12.3025 26.2501C12.7201 25.1673 13.77 24.3987 15 24.3987C16.23 24.3987 17.2799 25.1672 17.6975 26.2501C18.8796 25.9675 20.0095 25.4993 21.0451 24.8629C20.575 23.802 20.774 22.5164 21.6437 21.6468C22.2079 21.0824 22.9472 20.8005 23.6867 20.8005C24.0872 20.8005 24.4877 20.8832 24.8605 21.0485C25.4972 20.0131 25.9657 18.8833 26.2487 17.7012C25.1648 17.284 24.3954 16.2335 24.3954 15.0027ZM15.0527 19.6816C12.457 19.6816 10.3652 17.5781 10.3652 14.9941C10.3652 12.4101 12.457 10.3066 15.0527 10.3066C17.6484 10.3066 19.7402 12.4101 19.7402 14.9941C19.7402 17.5781 17.6484 19.6816 15.0527 19.6816Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export const PalletIcon = ({ fill, fill2 }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_211_70)">
        <path
          d="M3.20935 12.4792C3.20935 12.4792 1.93164 4.57109 11.7422 2.99512C11.7422 2.99512 21.5528 3.2692 20.4887 11.9149C20.4887 11.9149 21.1416 16.0302 13.0804 15.4457C13.0804 15.4457 9.78734 17.2998 12.77 20.0769L11.8792 20.8307C11.8792 20.8307 4.2291 20.8669 3.20935 12.4792Z"
          fill={fill || 'white'}
        />
        <path
          d="M12 3.61225C16.6231 3.61225 20.3877 6.87707 20.3877 10.8875C20.3846 11.9327 19.9677 12.9341 19.2282 13.6728C18.4888 14.4115 17.4869 14.8274 16.4418 14.8295H14.4708C13.8387 14.8317 13.2208 15.0169 12.6917 15.3627C12.1626 15.7084 11.745 16.2 11.4892 16.778C11.2335 17.356 11.1505 17.9957 11.2505 18.6199C11.3504 19.244 11.6289 19.8258 12.0524 20.295C12.0571 20.3067 12.0571 20.3197 12.0524 20.3313C12.0551 20.3377 12.0564 20.3446 12.0564 20.3515C12.0564 20.3584 12.0551 20.3652 12.0524 20.3716C12.0408 20.3763 12.0278 20.3763 12.0161 20.3716C9.85718 20.279 7.81727 19.3567 6.32161 17.797C4.82596 16.2373 3.98996 14.1606 3.98788 11.9997C3.9858 9.83872 4.8178 7.76036 6.31045 6.19779C7.80311 4.63523 9.84124 3.70902 12 3.61225ZM12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C12.3228 21.9994 12.6385 21.9052 12.9088 21.7288C13.1791 21.5524 13.3925 21.3014 13.523 21.0062C13.6535 20.711 13.6957 20.3842 13.6443 20.0656C13.5928 19.7469 13.4501 19.45 13.2334 19.2108C13.0193 18.9719 12.8789 18.6761 12.8293 18.3592C12.7797 18.0423 12.8229 17.7177 12.9538 17.4249C13.0847 17.132 13.2976 16.8833 13.5668 16.7088C13.836 16.5343 14.15 16.4416 14.4708 16.4418H16.4418C17.9149 16.4407 19.3274 15.8553 20.3694 14.814C21.4115 13.7728 21.9979 12.3607 22 10.8875C22 5.97823 17.522 2.02015 12 2.02015V2Z"
          fill="#C6C6C6"
        />
        <path
          d="M6.50608 13.491C6.17587 13.491 5.85309 13.393 5.57859 13.2095C5.30409 13.0259 5.09022 12.7651 4.96404 12.4599C4.83786 12.1548 4.80505 11.8191 4.86976 11.4953C4.93448 11.1715 5.0938 10.8741 5.32758 10.6409C5.56135 10.4077 5.85906 10.2491 6.18301 10.1852C6.50697 10.1212 6.84261 10.1549 7.14745 10.2818C7.4523 10.4087 7.71263 10.6232 7.8955 10.8982C8.07837 11.1731 8.17556 11.4961 8.17476 11.8263C8.1737 12.2675 7.99797 12.6903 7.68602 13.0022C7.37407 13.3142 6.95128 13.4899 6.51011 13.491H6.50608ZM9.18645 8.44865C8.85626 8.44624 8.5342 8.34592 8.26105 8.1604C7.9879 7.97487 7.77593 7.71247 7.65198 7.40642C7.52802 7.10037 7.49765 6.76442 7.56472 6.4411C7.63178 6.11779 7.79326 5.82163 8.02871 5.59013C8.26417 5.35863 8.56301 5.20218 8.88742 5.1406C9.21183 5.07902 9.54721 5.11507 9.85112 5.24419C10.155 5.37331 10.4138 5.58969 10.5947 5.86594C10.7756 6.1422 10.8704 6.4659 10.8672 6.79609C10.863 7.23655 10.6847 7.65746 10.3714 7.96704C10.058 8.27661 9.63499 8.44973 9.19451 8.44865H9.18645ZM14.7769 8.48089C14.4459 8.48086 14.1223 8.38235 13.8474 8.1979C13.5725 8.01345 13.3587 7.7514 13.2331 7.44508C13.1075 7.13875 13.0759 6.80201 13.1423 6.47767C13.2087 6.15334 13.37 5.85607 13.6058 5.62369C13.8416 5.39132 14.1412 5.23433 14.4665 5.1727C14.7917 5.11107 15.128 5.14758 15.4324 5.2776C15.7369 5.40761 15.9958 5.62525 16.1762 5.90283C16.3566 6.18041 16.4504 6.50537 16.4456 6.8364C16.4462 7.05481 16.4036 7.27118 16.3204 7.47313C16.2372 7.67507 16.1149 7.85861 15.9607 8.01324C15.8064 8.16787 15.6232 8.29055 15.4214 8.37426C15.2197 8.45796 15.0034 8.50105 14.785 8.50105L14.7769 8.48089ZM17.0825 13.1322C16.7523 13.133 16.4292 13.0359 16.1543 12.853C15.8794 12.6701 15.6648 12.4098 15.5379 12.1049C15.411 11.8001 15.3774 11.4645 15.4413 11.1405C15.5053 10.8165 15.6639 10.5188 15.8971 10.2851C16.1303 10.0513 16.4276 9.89196 16.7514 9.82724C17.0752 9.76253 17.4109 9.79534 17.7161 9.92152C18.0212 10.0477 18.2821 10.2616 18.4656 10.5361C18.6491 10.8106 18.7471 11.1334 18.7471 11.4636C18.7476 11.6822 18.7051 11.8987 18.6219 12.1009C18.5388 12.3031 18.4166 12.4869 18.2624 12.6418C18.1082 12.7968 17.925 12.9198 17.7232 13.004C17.5215 13.0881 17.3051 13.1317 17.0865 13.1322H17.0825Z"
          fill={fill2 || '#4D77B6'}
        />
      </g>
      <defs>
        <clipPath id="clip0_211_70">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BoxShapeIcon = ({ color = '#5186BD' }) => {
  return (
    <svg
      width="44"
      height="51"
      viewBox="0 0 44 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.9603 12.6902L21.9801 0L0 12.6902L21.9801 22.7512L43.9603 12.6902Z"
        fill={color}
        opacity={1}
      />
      <path
        d="M0 38.0972V12.6631L22 22.7509V50.7606L0 38.0972Z"
        fill={color}
        opacity={0.9}
      />
      <path
        d="M44 38.0972V12.6631L22 22.7509V50.7606L44 38.0972Z"
        fill={color}
        opacity={1}
      />
    </svg>
  );
};

export const IconPreview = () => {
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6 10.9C13.7 11 13.8 11 14 11H21C21.6 11 22 10.6 22 10C22 9.8 22 9.7 21.9 9.6L18.4 2.6C18.1 2.1 17.5 1.9 17 2.2C16.9 2.3 16.7 2.4 16.6 2.6L13.1 9.6C12.9 10 13.1 10.6 13.6 10.9ZM17.5 5.2L19.4 9H15.6L17.5 5.2ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2ZM6.5 9C5.1 9 4 7.9 4 6.5C4 5.1 5.1 4 6.5 4C7.9 4 9 5.1 9 6.5C9 7.9 7.9 9 6.5 9ZM10.7 13.3C10.3 12.9 9.7 12.9 9.3 13.3L6.5 16.1L3.7 13.3C3.3 12.9 2.7 12.9 2.3 13.3C1.9 13.7 1.9 14.3 2.3 14.7L5.1 17.5L2.3 20.3C1.9 20.7 1.9 21.3 2.3 21.7C2.7 22.1 3.3 22.1 3.7 21.7L6.5 18.9L9.3 21.7C9.7 22.1 10.3 22.1 10.7 21.7C11.1 21.3 11.1 20.7 10.7 20.3L7.9 17.5L10.7 14.7C11.1 14.3 11.1 13.7 10.7 13.3ZM21 13H14C13.4 13 13 13.4 13 14V21C13 21.6 13.4 22 14 22H21C21.6 22 22 21.6 22 21V14C22 13.4 21.6 13 21 13ZM20 20H15V15H20V20Z"
      fill="white"
    />
  </svg>;
};
export const CloseCircle = ({ fill = 'black' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7101 8.28983C15.6171 8.19611 15.5065 8.12171 15.3847 8.07094C15.2628 8.02018 15.1321 7.99404 15.0001 7.99404C14.8681 7.99404 14.7374 8.02018 14.6155 8.07094C14.4936 8.12171 14.383 8.19611 14.2901 8.28983L12.0001 10.5898L9.71008 8.28983C9.52178 8.10153 9.26638 7.99574 9.00008 7.99574C8.73378 7.99574 8.47838 8.10153 8.29008 8.28983C8.10178 8.47814 7.99599 8.73353 7.99599 8.99984C7.99599 9.26614 8.10178 9.52153 8.29008 9.70984L10.5901 11.9998L8.29008 14.2898C8.19635 14.3828 8.12196 14.4934 8.07119 14.6153C8.02042 14.7371 7.99428 14.8678 7.99428 14.9998C7.99428 15.1318 8.02042 15.2626 8.07119 15.3844C8.12196 15.5063 8.19635 15.6169 8.29008 15.7098C8.38304 15.8036 8.49364 15.878 8.6155 15.9287C8.73736 15.9795 8.86807 16.0056 9.00008 16.0056C9.13209 16.0056 9.2628 15.9795 9.38466 15.9287C9.50652 15.878 9.61712 15.8036 9.71008 15.7098L12.0001 13.4098L14.2901 15.7098C14.383 15.8036 14.4936 15.878 14.6155 15.9287C14.7374 15.9795 14.8681 16.0056 15.0001 16.0056C15.1321 16.0056 15.2628 15.9795 15.3847 15.9287C15.5065 15.878 15.6171 15.8036 15.7101 15.7098C15.8038 15.6169 15.8782 15.5063 15.929 15.3844C15.9797 15.2626 16.0059 15.1318 16.0059 14.9998C16.0059 14.8678 15.9797 14.7371 15.929 14.6153C15.8782 14.4934 15.8038 14.3828 15.7101 14.2898L13.4101 11.9998L15.7101 9.70984C15.8038 9.61687 15.8782 9.50627 15.929 9.38441C15.9797 9.26255 16.0059 9.13185 16.0059 8.99984C16.0059 8.86782 15.9797 8.73712 15.929 8.61526C15.8782 8.4934 15.8038 8.3828 15.7101 8.28983ZM19.0701 4.92984C18.1476 3.97473 17.0442 3.21291 15.8241 2.68882C14.6041 2.16473 13.2919 1.88887 11.9641 1.87733C10.6363 1.86579 9.3195 2.11881 8.09054 2.62162C6.86158 3.12443 5.74506 3.86696 4.80613 4.80589C3.8672 5.74481 3.12467 6.86133 2.62186 8.09029C2.11905 9.31926 1.86604 10.6361 1.87757 11.9638C1.88911 13.2916 2.16498 14.6038 2.68907 15.8239C3.21316 17.0439 3.97498 18.1474 4.93008 19.0698C5.85255 20.0249 6.95599 20.7868 8.17603 21.3109C9.39607 21.8349 10.7083 22.1108 12.0361 22.1223C13.3639 22.1339 14.6807 21.8809 15.9096 21.3781C17.1386 20.8752 18.2551 20.1327 19.194 19.1938C20.133 18.2549 20.8755 17.1383 21.3783 15.9094C21.8811 14.6804 22.1341 13.3636 22.1226 12.0358C22.111 10.708 21.8352 9.39583 21.3111 8.17579C20.787 6.95575 20.0252 5.8523 19.0701 4.92984ZM17.6601 17.6598C16.3521 18.9692 14.6306 19.7847 12.7889 19.9671C10.9471 20.1496 9.09909 19.6879 7.5596 18.6606C6.02012 17.6333 4.88444 16.104 4.34605 14.3333C3.80767 12.5626 3.89988 10.66 4.60699 8.94962C5.3141 7.23926 6.59235 5.82698 8.22397 4.9534C9.85559 4.07981 11.7396 3.79897 13.5551 4.15871C15.3705 4.51845 17.0051 5.49653 18.1803 6.9263C19.3555 8.35607 19.9986 10.1491 20.0001 11.9998C20.0036 13.0511 19.7987 14.0927 19.397 15.0642C18.9953 16.0358 18.405 16.918 17.6601 17.6598Z"
        fill={fill}
      />
    </svg>
  );
};

export const MenuIcon = ({ fill = 'black' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10C11.6044 10 11.2178 10.1173 10.8889 10.3371C10.56 10.5568 10.3036 10.8692 10.1522 11.2346C10.0009 11.6001 9.96126 12.0022 10.0384 12.3902C10.1156 12.7781 10.3061 13.1345 10.5858 13.4142C10.8655 13.6939 11.2219 13.8844 11.6098 13.9616C11.9978 14.0387 12.3999 13.9991 12.7654 13.8478C13.1308 13.6964 13.4432 13.44 13.6629 13.1111C13.8827 12.7822 14 12.3956 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10ZM5 10C4.60444 10 4.21776 10.1173 3.88886 10.3371C3.55996 10.5568 3.30362 10.8692 3.15224 11.2346C3.00087 11.6001 2.96126 12.0022 3.03843 12.3902C3.1156 12.7781 3.30608 13.1345 3.58579 13.4142C3.86549 13.6939 4.22186 13.8844 4.60982 13.9616C4.99778 14.0387 5.39992 13.9991 5.76537 13.8478C6.13082 13.6964 6.44318 13.44 6.66294 13.1111C6.8827 12.7822 7 12.3956 7 12C7 11.4696 6.78929 10.9609 6.41421 10.5858C6.03914 10.2107 5.53043 10 5 10ZM19 10C18.6044 10 18.2178 10.1173 17.8889 10.3371C17.56 10.5568 17.3036 10.8692 17.1522 11.2346C17.0009 11.6001 16.9613 12.0022 17.0384 12.3902C17.1156 12.7781 17.3061 13.1345 17.5858 13.4142C17.8655 13.6939 18.2219 13.8844 18.6098 13.9616C18.9978 14.0387 19.3999 13.9991 19.7654 13.8478C20.1308 13.6964 20.4432 13.44 20.6629 13.1111C20.8827 12.7822 21 12.3956 21 12C21 11.4696 20.7893 10.9609 20.4142 10.5858C20.0391 10.2107 19.5304 10 19 10Z"
        fill={fill}
      />
    </svg>
  );
};

export const AskAIIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-message-chatbot"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" />
      <path d="M9.5 9h.01" />
      <path d="M14.5 9h.01" />
      <path d="M9.5 13a3.5 3.5 0 0 0 5 0" />
    </svg>
  );
};

export const AddPerspIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
    >
      <path
        d="M24,8.5c0-.524-.274-1.012-.724-1.283L13.864,1.521c-1.15-.695-2.578-.697-3.728,0L.724,7.217c-.449,.271-.724,.759-.724,1.283s.274,1.012,.724,1.283l9.412,5.696c.575,.348,1.22,.522,1.864,.522s1.289-.174,1.863-.522l9.413-5.696c.449-.271,.724-.759,.724-1.283Zm-11.69,4.413c-.19,.114-.428,.114-.62,0l-7.292-4.413,7.292-4.413h0c.189-.115,.427-.116,.62,0l7.292,4.413-7.293,4.413Zm11.69,6.587c0,.828-.671,1.5-1.5,1.5h-1.5v1.5c0,.828-.671,1.5-1.5,1.5s-1.5-.672-1.5-1.5v-1.5h-1.5c-.829,0-1.5-.672-1.5-1.5s.671-1.5,1.5-1.5h1.5v-1.5c0-.828,.671-1.5,1.5-1.5s1.5,.672,1.5,1.5v1.5h1.5c.829,0,1.5,.672,1.5,1.5Zm-11.214,1.771c-.281,.469-.778,.729-1.288,.729-.263,0-.529-.068-.771-.214L.822,15.843c-.71-.426-.94-1.348-.514-2.058,.426-.711,1.348-.942,2.058-.515l9.906,5.943c.71,.426,.94,1.348,.514,2.058Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const ScaleIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.0234 11.8359C23.7748 11.8359 23.5363 11.7372 23.3605 11.5613C23.1847 11.3855 23.0859 11.1471 23.0859 10.8984V6.91406H19.1016C18.8529 6.91406 18.6145 6.81529 18.4386 6.63947C18.2628 6.46366 18.1641 6.2252 18.1641 5.97656C18.1641 5.72792 18.2628 5.48947 18.4386 5.31365C18.6145 5.13783 18.8529 5.03906 19.1016 5.03906H24.0234C24.2721 5.03906 24.5105 5.13783 24.6864 5.31365C24.8622 5.48947 24.9609 5.72792 24.9609 5.97656V10.8984C24.9609 11.1471 24.8622 11.3855 24.6864 11.5613C24.5105 11.7372 24.2721 11.8359 24.0234 11.8359ZM10.8984 24.9609H5.97656C5.72792 24.9609 5.48947 24.8622 5.31365 24.6864C5.13783 24.5105 5.03906 24.2721 5.03906 24.0234V19.1016C5.03906 18.8529 5.13783 18.6145 5.31365 18.4386C5.48947 18.2628 5.72792 18.1641 5.97656 18.1641C6.2252 18.1641 6.46366 18.2628 6.63947 18.4386C6.81529 18.6145 6.91406 18.8529 6.91406 19.1016V23.0859H10.8984C11.1471 23.0859 11.3855 23.1847 11.5613 23.3605C11.7372 23.5363 11.8359 23.7748 11.8359 24.0234C11.8359 24.2721 11.7372 24.5105 11.5613 24.6864C11.3855 24.8622 11.1471 24.9609 10.8984 24.9609Z"
        fill="#ffffff"
      />
      <path
        d="M5.97661 24.9611C5.79122 24.9611 5.61 24.9061 5.45586 24.8031C5.30173 24.7001 5.1816 24.5537 5.11066 24.3824C5.03972 24.2111 5.02115 24.0226 5.05731 23.8408C5.09347 23.659 5.18272 23.4919 5.31379 23.3608L23.3607 5.31395C23.5375 5.14318 23.7743 5.04868 24.0201 5.05082C24.2659 5.05295 24.5011 5.15155 24.6749 5.32537C24.8487 5.49919 24.9473 5.73433 24.9494 5.98014C24.9516 6.22594 24.8571 6.46276 24.6863 6.63957L6.63942 24.6865C6.55248 24.7736 6.44917 24.8428 6.33542 24.8899C6.22167 24.9371 6.09973 24.9613 5.97661 24.9611Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const ZoomIn = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3793 20.1721C16.2356 20.1721 20.1724 16.2353 20.1724 11.379C20.1724 6.52274 16.2356 2.58594 11.3793 2.58594C6.52299 2.58594 2.58618 6.52274 2.58618 11.379C2.58618 16.2353 6.52299 20.1721 11.3793 20.1721Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M26.8077 23.8822L19.2353 16.3098C19.1174 16.1949 18.9865 16.0942 18.8453 16.0098C18.1301 17.1599 17.1599 18.1301 16.0098 18.8453C16.0936 18.9839 16.1898 19.1163 16.3098 19.2353L23.8822 26.8077C24.2867 27.2122 24.8153 27.4139 25.3449 27.4139C25.8746 27.4139 26.4032 27.2122 26.8077 26.8077C27.1956 26.4197 27.4135 25.8936 27.4135 25.3449C27.4135 24.7963 27.1956 24.2702 26.8077 23.8822Z"
        fill="white"
      />
      <path
        d="M11.3794 16.035V6.72461"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.72412 11.3789H16.0345"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3793 20.1721C16.2356 20.1721 20.1724 16.2353 20.1724 11.379C20.1724 6.52274 16.2356 2.58594 11.3793 2.58594C6.52299 2.58594 2.58618 6.52274 2.58618 11.379C2.58618 16.2353 6.52299 20.1721 11.3793 20.1721Z"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M26.8075 23.8822L19.235 16.3098C19.1172 16.1949 18.9863 16.0942 18.845 16.0098C18.1299 17.1599 17.1597 18.1301 16.0095 18.8453C16.0933 18.9839 16.1895 19.1163 16.3095 19.2353L23.8819 26.8077C24.2864 27.2122 24.815 27.4139 25.3447 27.4139C25.8743 27.4139 26.403 27.2122 26.8075 26.8077C27.1953 26.4197 27.4132 25.8936 27.4132 25.3449C27.4132 24.7963 27.1953 24.2702 26.8075 23.8822Z"
        fill="white"
      />
      <path
        d="M11.3794 16.034V6.72363"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.72412 11.3789H16.0345"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ZoomOut = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3793 21.2069C5.96072 21.2069 1.55176 16.798 1.55176 11.3793C1.55176 5.96072 5.96072 1.55176 11.3793 1.55176C16.798 1.55176 21.2069 5.96072 21.2069 11.3793C21.2069 16.798 16.798 21.2069 11.3793 21.2069ZM11.3793 3.62072C7.10072 3.62072 3.62072 7.10072 3.62072 11.3793C3.62072 15.658 7.10072 19.138 11.3793 19.138C15.658 19.138 19.138 15.658 19.138 11.3793C19.138 7.10072 15.658 3.62072 11.3793 3.62072Z"
        fill="white"
      />
      <path
        d="M26.8077 23.8822L19.2353 16.3098C19.1174 16.1949 18.9865 16.0942 18.8453 16.0098C18.1301 17.1599 17.1599 18.1301 16.0098 18.8453C16.0936 18.9839 16.1898 19.1163 16.3098 19.2353L23.8822 26.8077C24.2867 27.2122 24.8153 27.4139 25.3449 27.4139C25.8746 27.4139 26.4032 27.2122 26.8077 26.8077C27.1956 26.4197 27.4135 25.8936 27.4135 25.3449C27.4135 24.7963 27.1956 24.2702 26.8077 23.8822Z"
        fill="white"
      />
      <path
        d="M16.0345 12.4137H6.72418C6.44982 12.4137 6.18669 12.3047 5.99269 12.1107C5.79869 11.9167 5.6897 11.6536 5.6897 11.3792C5.6897 11.1048 5.79869 10.8417 5.99269 10.6477C6.18669 10.4537 6.44982 10.3447 6.72418 10.3447H16.0345C16.3089 10.3447 16.572 10.4537 16.766 10.6477C16.96 10.8417 17.069 11.1048 17.069 11.3792C17.069 11.6536 16.96 11.9167 16.766 12.1107C16.572 12.3047 16.3089 12.4137 16.0345 12.4137Z"
        fill="white"
      />
    </svg>
  );
};
export const HistoryIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_303_69)">
        <path
          opacity="0.9"
          d="M16.2437 3.75C10.025 3.75 5 8.7875 5 15H1.25L6.11875 19.8688L6.20625 20.05L11.25 15H7.5C7.5 10.1687 11.4187 6.25 16.25 6.25C21.0813 6.25 25 10.1687 25 15C25 19.8313 21.0813 23.75 16.25 23.75C13.8313 23.75 11.65 22.7625 10.0688 21.1812L8.3 22.95C10.3312 24.9875 13.1375 26.25 16.2437 26.25C22.4625 26.25 27.5 21.2125 27.5 15C27.5 8.7875 22.4625 3.75 16.2437 3.75ZM15 10V16.25L20.35 19.425L21.25 17.9062L16.875 15.3125V10H15Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_303_69">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SearchIcon = ({ fill = 'grey' }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5301 18.75C6.26102 20.4834 8.56606 21.524 11.011 21.6757C13.4559 21.8274 15.8719 21.0798 17.8039 19.5738L24.4514 26.2213C24.6871 26.449 25.0029 26.575 25.3306 26.5721C25.6583 26.5693 25.9719 26.4378 26.2036 26.2061C26.4354 25.9743 26.5668 25.6608 26.5697 25.333C26.5725 25.0053 26.4466 24.6895 26.2189 24.4538L19.5714 17.8063C21.1442 15.7877 21.8879 13.2452 21.6506 10.6973C21.4133 8.14928 20.213 5.78778 18.2945 4.09437C16.3759 2.40095 13.8836 1.50318 11.3259 1.58414C8.76822 1.66509 6.33771 2.71869 4.5301 4.53004C3.5961 5.46357 2.85518 6.57197 2.34968 7.79193C1.84417 9.01189 1.58398 10.3195 1.58398 11.64C1.58398 12.9606 1.84417 14.2682 2.34968 15.4881C2.85518 16.7081 3.5961 17.8165 4.5301 18.75ZM6.2976 6.30004C7.53332 5.06435 9.15926 4.29534 10.8984 4.12404C12.6375 3.95273 14.3822 4.38973 15.8353 5.36057C17.2884 6.33141 18.3599 7.77604 18.8672 9.44831C19.3746 11.1206 19.2865 12.917 18.6178 14.5316C17.9492 16.1462 16.7414 17.479 15.2003 18.3029C13.6591 19.1268 11.88 19.3909 10.166 19.0502C8.452 18.7094 6.90916 17.7849 5.80035 16.4342C4.69154 15.0835 4.08537 13.3901 4.0851 11.6425C4.08167 10.6495 4.27548 9.66568 4.65529 8.74814C5.03509 7.8306 5.59333 6.99763 6.2976 6.29754V6.30004Z"
        fill={fill}
      />
    </svg>
  );
};

export const InterfaceIcon = ({ fill = '#5E889E' }) => {
  return (
    <svg
      id="light"
      fill="none"
      height="30"
      viewBox="0 0 24 24"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path
            d="m20.5 5c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5zm0-4c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"
            fill={fill}
          />
        </g>
        <g>
          <path
            d="m23.5 6c-.128 0-.256-.049-.354-.146l-1.5-1.5c-.195-.195-.195-.512 0-.707s.512-.195.707 0l1.5 1.5c.195.195.195.512 0 .707-.097.097-.225.146-.353.146z"
            fill={fill}
          />
        </g>
      </g>
      <g>
        <path
          d="m14.5 6h-13c-.827 0-1.5-.673-1.5-1.5v-3c0-.827.673-1.5 1.5-1.5h13c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5zm-13-5c-.275 0-.5.225-.5.5v3c0 .275.225.5.5.5h13c.275 0 .5-.225.5-.5v-3c0-.275-.225-.5-.5-.5z"
          fill={fill}
        />
      </g>
      <g>
        <path
          d="m3 24c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
          fill={fill}
        />
      </g>
      <g>
        <path
          d="m5.5 13h-5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h5c.276 0 .5.224.5.5s-.224.5-.5.5z"
          fill={fill}
        />
      </g>
      <g>
        <path
          d="m5.5 16h-5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h5c.276 0 .5.224.5.5s-.224.5-.5.5z"
          fill={fill}
        />
      </g>
      <g>
        <path
          d="m5.5 10h-5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h5c.276 0 .5.224.5.5s-.224.5-.5.5z"
          fill={fill}
        />
      </g>
      <g>
        <path
          d="m22.5 24h-13c-.827 0-1.5-.673-1.5-1.5v-13c0-.827.673-1.5 1.5-1.5h13c.827 0 1.5.673 1.5 1.5v13c0 .827-.673 1.5-1.5 1.5zm-13-15c-.275 0-.5.225-.5.5v13c0 .275.225.5.5.5h13c.275 0 .5-.225.5-.5v-13c0-.275-.225-.5-.5-.5z"
          fill={fill}
        />
      </g>
      <g>
        <g>
          <path d="m16 15c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2c-.275 0-.5.225-.5.5s.225.5.5.5.5-.225.5-.5-.225-.5-.5-.5z" />
        </g>
        <g>
          <path
            d="m18.5 19c-.276 0-.5-.224-.5-.5v-.5c0-.552-.448-1-1-1h-2c-.552 0-1 .448-1 1v.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-.5c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v.5c0 .276-.224.5-.5.5z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
};

export const BusinessIcon = ({ fill = '#5E889E' }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_312_426)">
        <path
          d="M20.3258 8.2526C20.2856 8.0765 20.1877 7.9097 20.0335 7.775C19.8794 7.64165 19.6898 7.5605 19.4933 7.53095L16.3396 6.9209L17.2519 7.5266L15.8113 12.0422L15.0001 8.68745L14.1886 12.0422L12.7489 7.5266L13.6609 6.9209L10.5067 7.53095C10.3072 7.56008 10.1199 7.64464 9.9662 7.775C9.81185 7.90955 9.71465 8.07635 9.67445 8.2526L8.7395 12.3605L10.5035 12.9725C11.0894 13.5815 12.7282 14.0292 14.6945 14.0715H15.3059C17.2717 14.0292 18.9104 13.5813 19.4966 12.9725L21.2617 12.3605L20.3258 8.2526Z"
          fill={fill}
        />
        <path
          d="M15 7.37957L14.2726 7.64012L15 8.68802L15.7276 7.64012L15 7.37957ZM17.6992 3.33512C17.6992 1.47077 16.9321 0.00976562 14.9998 0.00976562C13.0672 0.00976562 12.3 1.47077 12.3 3.33512C12.0987 3.44027 11.9661 3.68792 12.1645 4.21817C12.2644 4.48472 12.441 4.70777 12.5907 4.82432C13.1412 6.19487 14.2242 7.25387 15 7.25387C15.7758 7.25387 16.8588 6.19487 17.4091 4.82417C17.5596 4.70777 17.7352 4.48472 17.8359 4.21802C18.0339 3.68792 17.9016 3.44027 17.6992 3.33512ZM25.7878 18.2396C25.7106 17.9404 25.5317 17.6774 25.2817 17.4957C25.0317 17.314 24.7263 17.225 24.4179 17.2439L23.731 15.7304H15.2538V14.6376H14.746V15.7304H6.26835L5.58225 17.2439C5.27376 17.2249 4.96829 17.3139 4.71827 17.4956C4.46824 17.6773 4.28924 17.9403 4.212 18.2396C4.0281 18.9512 4.45635 19.6776 5.1681 19.8617C5.8806 20.0454 6.6072 19.617 6.7908 18.9045C6.9531 18.2765 6.6384 17.6384 6.07335 17.3702L6.66165 16.2374H14.746V17.33C14.1322 17.4489 13.6681 17.9885 13.6681 18.6374C13.6681 18.8122 13.7026 18.9854 13.7695 19.1469C13.8365 19.3085 13.9345 19.4553 14.0582 19.5789C14.1819 19.7026 14.3287 19.8006 14.4903 19.8675C14.6518 19.9344 14.825 19.9688 14.9998 19.9688C15.1747 19.9688 15.3479 19.9344 15.5094 19.8675C15.671 19.8006 15.8177 19.7025 15.9414 19.5789C16.065 19.4553 16.1631 19.3085 16.23 19.1469C16.2969 18.9854 16.3313 18.8122 16.3312 18.6374C16.3313 18.3283 16.2238 18.0289 16.0272 17.7904C15.8305 17.552 15.5571 17.3894 15.2536 17.3306V16.2374H23.3383L23.9262 17.3702C23.6275 17.5126 23.3926 17.7611 23.2672 18.0673C23.1418 18.3735 23.1349 18.7155 23.2478 19.0265C23.3607 19.3375 23.5854 19.5953 23.8781 19.7497C24.1707 19.9041 24.5104 19.944 24.8308 19.8617C25.5432 19.6776 25.9716 18.9516 25.7878 18.2396ZM6.3 18.7782C6.24507 18.9897 6.10851 19.1708 5.92026 19.2818C5.732 19.3928 5.50742 19.4246 5.29575 19.3703C5.0842 19.3154 4.90304 19.1788 4.792 18.9906C4.68096 18.8023 4.6491 18.5777 4.7034 18.366C4.75829 18.1544 4.89487 17.9733 5.08317 17.8623C5.27147 17.7513 5.49611 17.7195 5.7078 17.774C6.1473 17.8874 6.41295 18.3381 6.3 18.7782ZM15.8244 18.6374C15.8244 19.0919 15.4539 19.4612 14.9998 19.4612C14.545 19.4612 14.1753 19.0919 14.1753 18.6374C14.1753 18.1829 14.5449 17.813 14.9998 17.813C15.2184 17.8133 15.4279 17.9003 15.5824 18.0548C15.737 18.2093 15.824 18.4188 15.8244 18.6374ZM24.7042 19.3703C24.4927 19.4247 24.2681 19.3929 24.0799 19.2819C23.8917 19.1709 23.7553 18.9897 23.7006 18.7782C23.646 18.5665 23.6778 18.3419 23.7888 18.1535C23.8998 17.9652 24.081 17.8287 24.2926 17.774C24.5043 17.7194 24.729 17.7511 24.9173 17.8622C25.1056 17.9733 25.242 18.1546 25.2966 18.3663C25.3512 18.578 25.3194 18.8027 25.2083 18.991C25.0973 19.1792 24.9159 19.3157 24.7042 19.3703ZM7.71465 26.1161C7.689 25.9989 7.62345 25.8879 7.52055 25.7981C7.41859 25.7109 7.29395 25.6544 7.16115 25.6353L4.80795 25.1787C5.1768 24.8918 5.54415 24.4029 5.7732 23.8328C5.8728 23.7546 5.99055 23.6063 6.05715 23.4293C6.18945 23.0763 6.1008 22.9116 5.96625 22.8414C5.96625 21.6 5.4555 20.6267 4.1691 20.6267C2.8824 20.6267 2.37165 21.5999 2.37165 22.8414C2.23725 22.9116 2.1489 23.0763 2.2809 23.4293C2.3472 23.6064 2.46525 23.7548 2.56515 23.8328C2.79345 24.4029 3.1608 24.8918 3.5301 25.1787L1.1769 25.6353C1.044 25.6547 0.919247 25.7111 0.8169 25.7981C0.71445 25.8881 0.64965 25.9989 0.62295 26.1161L0 28.8519L1.1745 29.2593C1.5648 29.6645 2.65575 29.9627 3.9651 29.9906H4.3725C5.6817 29.9627 6.77325 29.6645 7.16325 29.2593L8.33775 28.8519L7.71465 26.1161ZM29.3773 26.1161C29.3506 25.9989 29.2854 25.8879 29.1831 25.7981C29.0809 25.7111 28.9562 25.6546 28.8234 25.6353L26.47 25.1787C26.8395 24.8918 27.2067 24.4029 27.4353 23.8328C27.5355 23.7546 27.6526 23.6063 27.7197 23.4293C27.852 23.0763 27.763 22.9116 27.6288 22.8414C27.6288 21.6 27.118 20.6267 25.8316 20.6267C24.5446 20.6267 24.0345 21.5999 24.0345 22.8414C23.9001 22.9116 23.8113 23.0763 23.9436 23.4293C24.0099 23.6064 24.1278 23.7548 24.2274 23.8328C24.457 24.4029 24.8242 24.8918 25.1931 25.1787L22.8397 25.6353C22.7069 25.6545 22.5822 25.7109 22.48 25.7981C22.3777 25.8881 22.312 25.9989 22.2858 26.1161L21.6627 28.8518L22.8378 29.2592C23.2275 29.6643 24.319 29.9625 25.6284 29.9904H26.0352C27.3441 29.9625 28.4356 29.6643 28.8258 29.2592L30.0004 28.8518L29.3773 26.1161ZM18.5463 26.1161C18.5194 25.9989 18.4548 25.8879 18.3519 25.7981C18.2496 25.7108 18.1247 25.6544 17.9916 25.6353L15.6387 25.1787C16.0087 24.8918 16.3753 24.4029 16.6041 23.8328C16.7041 23.7546 16.8213 23.6063 16.8877 23.4293C17.0206 23.0763 16.9323 22.9116 16.7973 22.8414C16.7973 21.6 16.2865 20.6267 15 20.6267C13.713 20.6267 13.2025 21.5999 13.2025 22.8414C13.0681 22.9116 12.9798 23.0763 13.1118 23.4293C13.1787 23.6064 13.2964 23.7548 13.3956 23.8328C13.6246 24.4029 13.992 24.8918 14.3613 25.1787L12.0079 25.6353C11.875 25.6545 11.7502 25.7109 11.6479 25.7981C11.5456 25.8881 11.4807 25.9989 11.4537 26.1161L10.831 28.8518L12.006 29.2592C12.396 29.6643 13.4872 29.9625 14.7964 29.9904H15.204C16.513 29.9625 17.6046 29.6643 17.9944 29.2592L19.1695 28.8518L18.5463 26.1161Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_312_426">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CurrencyIcon = ({ fill = '#5E889E' }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9375 1.875C8.17125 1.875 1.875 8.17125 1.875 15.9375C1.875 23.7038 8.17125 30 15.9375 30C23.7038 30 30 23.7038 30 15.9375C30 8.17125 23.7038 1.875 15.9375 1.875ZM15.9375 28.125C9.2175 28.125 3.75 22.6575 3.75 15.9375C3.75 9.2175 9.2175 3.75 15.9375 3.75C22.6575 3.75 28.125 9.2175 28.125 15.9375C28.125 22.6575 22.6575 28.125 15.9375 28.125ZM17.5444 9.375C19.2431 9.375 20.625 10.6369 20.625 12.1875C20.625 12.4361 20.7238 12.6746 20.8996 12.8504C21.0754 13.0262 21.3139 13.125 21.5625 13.125C21.8111 13.125 22.0496 13.0262 22.2254 12.8504C22.4012 12.6746 22.5 12.4361 22.5 12.1875C22.5 9.60188 20.2763 7.5 17.5444 7.5H16.875V6.5625C16.875 6.31386 16.7762 6.0754 16.6004 5.89959C16.4246 5.72377 16.1861 5.625 15.9375 5.625C15.6889 5.625 15.4504 5.72377 15.2746 5.89959C15.0988 6.0754 15 6.31386 15 6.5625V7.5H14.3306C11.5988 7.5 9.375 9.60188 9.375 12.1875C9.375 14.7731 11.5988 16.875 14.3306 16.875H15V22.5H14.3306C12.6319 22.5 11.25 21.2381 11.25 19.6875C11.25 19.4389 11.1512 19.2004 10.9754 19.0246C10.7996 18.8488 10.5611 18.75 10.3125 18.75C10.0639 18.75 9.8254 18.8488 9.64959 19.0246C9.47377 19.2004 9.375 19.4389 9.375 19.6875C9.375 22.2731 11.5988 24.375 14.3306 24.375H15V25.3125C15 25.5611 15.0988 25.7996 15.2746 25.9754C15.4504 26.1512 15.6889 26.25 15.9375 26.25C16.1861 26.25 16.4246 26.1512 16.6004 25.9754C16.7762 25.7996 16.875 25.5611 16.875 25.3125V24.375H17.5444C20.2763 24.375 22.5 22.2731 22.5 19.6875C22.5 17.1019 20.2763 15 17.5444 15H16.875V9.375H17.5444ZM17.5444 16.875C19.2431 16.875 20.625 18.1369 20.625 19.6875C20.625 21.2381 19.2431 22.5 17.5444 22.5H16.875V16.875H17.5444ZM15 15H14.3306C12.6319 15 11.25 13.7381 11.25 12.1875C11.25 10.6369 12.6319 9.375 14.3306 9.375H15V15Z"
        fill={fill}
      />
    </svg>
  );
};
export const TimeIcon = ({ fill = '#5E889E' }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.2793 9.73828C26.4988 9.51819 26.6221 9.22003 26.6221 8.90918C26.6221 8.59833 26.4988 8.30017 26.2793 8.08008L25.3887 7.18945C25.1686 6.96995 24.8704 6.84668 24.5596 6.84668C24.2487 6.84668 23.9506 6.96995 23.7305 7.18945L22.6406 8.28516C20.9627 6.87469 18.9261 5.95782 16.7578 5.63672V4.33594H17.3789C17.6946 4.33163 17.9961 4.20432 18.2194 3.98108C18.4426 3.75784 18.5699 3.4563 18.5742 3.14062V1.88086C18.5742 1.23633 18.0234 0.703125 17.3789 0.703125H12.6211C11.9766 0.703125 11.4258 1.23633 11.4258 1.88086V3.14062C11.4311 3.45599 11.5587 3.75696 11.7817 3.97999C12.0048 4.20301 12.3057 4.33065 12.6211 4.33594H13.2422V5.63672C7.5 6.48047 3.09961 11.4375 3.09961 17.4023C3.09961 23.959 8.4375 29.291 14.9941 29.291C21.5508 29.291 26.8887 23.959 26.8887 17.4023C26.8934 15.1334 26.2423 12.9114 25.0137 11.0039L26.2793 9.73828ZM24.5566 8.02148L25.4473 8.91211L24.3281 10.0312C24.0645 9.70312 23.7891 9.38672 23.4902 9.08203L24.5566 8.02148ZM12.5977 3.16406V1.875H17.4023V3.16406H12.5977ZM14.4141 4.33594H15.5859V5.52539C15.3516 5.51367 15.1875 5.51367 15 5.51367C14.8125 5.51367 14.6484 5.51953 14.4141 5.52539V4.33594ZM15 28.1191C9.08789 28.1191 4.2832 23.3086 4.2832 17.4023C4.2832 11.4961 9.08789 6.67969 15 6.67969C20.9121 6.67969 25.7168 11.4902 25.7168 17.4023C25.7168 23.3145 20.9121 28.1191 15 28.1191Z"
        fill={fill}
      />
      <path
        d="M15 7.85156H14.8887C9.74418 7.91016 5.56644 12.0586 5.45511 17.1914C5.41322 17.273 5.39114 17.3633 5.39066 17.4551C5.38958 17.5514 5.41382 17.6464 5.46097 17.7305C5.63675 22.793 9.77347 26.8711 14.8594 26.9414C14.8865 26.9463 14.914 26.9482 14.9414 26.9473C14.965 26.9482 14.9886 26.9463 15.0118 26.9414C20.2735 26.9414 24.5508 22.6641 24.5508 17.4023C24.5508 12.1348 20.2676 7.85156 15 7.85156ZM15.5274 25.7578V24.668C15.5274 24.5126 15.4656 24.3635 15.3558 24.2536C15.2459 24.1438 15.0968 24.082 14.9414 24.082C14.786 24.082 14.637 24.1438 14.5271 24.2536C14.4172 24.3635 14.3555 24.5126 14.3555 24.668V25.752C10.2481 25.4355 6.96097 22.1543 6.65043 18.0469H7.67582C7.83122 18.0469 7.98025 17.9851 8.09014 17.8753C8.20002 17.7654 8.26175 17.6163 8.26175 17.4609C8.26175 17.3055 8.20002 17.1565 8.09014 17.0466C7.98025 16.9367 7.83122 16.875 7.67582 16.875H6.63871C6.76769 14.86 7.61905 12.9591 9.03654 11.5211C10.454 10.0832 12.3425 9.20471 14.3555 9.04687V10.1367C14.3555 10.2921 14.4172 10.4412 14.5271 10.551C14.637 10.6609 14.786 10.7227 14.9414 10.7227C15.0968 10.7227 15.2459 10.6609 15.3558 10.551C15.4656 10.4412 15.5274 10.2921 15.5274 10.1367V9.04102C17.562 9.17226 19.4792 10.0398 20.9209 11.4814C22.3626 12.9231 23.2301 14.8404 23.3614 16.875H22.2071C22.0517 16.875 21.9026 16.9367 21.7927 17.0466C21.6829 17.1565 21.6211 17.3055 21.6211 17.4609C21.6211 17.6163 21.6829 17.7654 21.7927 17.8753C21.9026 17.9851 22.0517 18.0469 22.2071 18.0469H23.3496C23.0332 22.1895 19.6875 25.5 15.5274 25.7578Z"
        fill={fill}
      />
      <path
        d="M18.3341 16.9336H15.5861V13.0605C15.5861 12.9051 15.5243 12.7561 15.4145 12.6462C15.3046 12.5363 15.1555 12.4746 15.0001 12.4746C14.8447 12.4746 14.6957 12.5363 14.5858 12.6462C14.4759 12.7561 14.4142 12.9051 14.4142 13.0605V17.5254C14.4126 17.601 14.4261 17.6762 14.4539 17.7466C14.4817 17.8169 14.5234 17.881 14.5763 17.935C14.6292 17.9891 14.6925 18.032 14.7622 18.0613C14.832 18.0905 14.9069 18.1056 14.9826 18.1055H18.3283C18.4837 18.1062 18.633 18.0453 18.7434 17.9359C18.8539 17.8266 18.9163 17.6779 18.9171 17.5225C18.9179 17.3671 18.8569 17.2177 18.7476 17.1073C18.6382 16.9968 18.4895 16.9344 18.3341 16.9336Z"
        fill={fill}
      />
    </svg>
  );
};

export const FlagsIcon = ({ fill = '#5E889E' }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_317_436)">
        <path
          d="M6.47803 2.81738C5.6999 2.81738 5.07178 2.18457 5.07178 1.41113C5.07178 0.633008 5.70459 0.00488281 6.47803 0.00488281C7.25146 0.00488281 7.88428 0.637695 7.88428 1.41113C7.88428 2.18457 7.25146 2.81738 6.47803 2.81738ZM6.47803 0.45957C5.95771 0.45957 5.53115 0.886133 5.53115 1.40645C5.53115 1.92676 5.95771 2.35332 6.47803 2.35332C6.99834 2.35332 7.4249 1.93145 7.4249 1.40645C7.4249 0.886133 6.99834 0.45957 6.47803 0.45957Z"
          fill={fill}
        />
        <path
          d="M6.47822 26.9207C6.35166 26.9207 6.24854 26.8176 6.24854 26.691V2.5832C6.24854 2.45664 6.35166 2.35352 6.47822 2.35352C6.60479 2.35352 6.70791 2.45664 6.70791 2.5832V26.6863C6.70791 26.8176 6.60479 26.9207 6.47822 26.9207Z"
          fill={fill}
        />
        <path
          d="M7.71543 28.2373H5.17012C5.04355 28.2373 4.94043 28.1342 4.94043 28.0076V27.342C4.94043 26.8545 5.33887 26.4561 5.82637 26.4561H7.05918C7.54668 26.4561 7.94512 26.8545 7.94512 27.342V28.0076C7.94512 28.1342 7.84199 28.2373 7.71543 28.2373ZM5.3998 27.7779H7.48105V27.3467C7.48105 27.1123 7.28887 26.9248 7.05918 26.9248H5.82637C5.59199 26.9248 5.40449 27.117 5.40449 27.3467V27.7779H5.3998Z"
          fill={fill}
        />
        <path
          d="M8.41387 30.0004H4.42012C4.29356 30.0004 4.19043 29.8973 4.19043 29.7707V28.0082C4.19043 27.8816 4.29356 27.7785 4.42012 27.7785H8.41387C8.54043 27.7785 8.64356 27.8816 8.64356 28.0082V29.7707C8.64824 29.8973 8.54512 30.0004 8.41387 30.0004ZM4.6498 29.541H8.18418V28.2426H4.6498V29.541ZM25.5795 15.9941H6.47793C6.35137 15.9941 6.24824 15.891 6.24824 15.7645C6.24824 15.6379 6.35137 15.5348 6.47793 15.5348H25.3498V4.73477H6.47793C6.35137 4.73477 6.24824 4.63164 6.24824 4.50508C6.24824 4.37852 6.35137 4.27539 6.47793 4.27539H25.5795C25.7061 4.27539 25.8092 4.37852 25.8092 4.50508V15.7691C25.8092 15.891 25.7061 15.9941 25.5795 15.9941Z"
          fill={fill}
        />
        <path
          d="M11.4982 15.9939C11.3717 15.9939 11.2686 15.8908 11.2686 15.7643V4.5002C11.2686 4.37363 11.3717 4.27051 11.4982 4.27051C11.6248 4.27051 11.7279 4.37363 11.7279 4.5002V15.7643C11.7326 15.8908 11.6295 15.9939 11.4982 15.9939ZM18.5389 10.7861C18.492 10.7861 18.4498 10.7721 18.4076 10.7439C18.3326 10.6924 18.2951 10.608 18.3092 10.5189L18.4826 9.32832L17.6061 8.40957C17.5498 8.34863 17.5264 8.26426 17.5545 8.17988C17.5779 8.1002 17.6436 8.03926 17.7279 8.02051L18.9654 7.75801L19.4811 6.76426C19.5186 6.68926 19.5936 6.64238 19.6779 6.64238C19.7576 6.63301 19.8373 6.67988 19.8842 6.75488L20.517 7.79082L21.717 7.90801C21.8061 7.91738 21.8811 7.97363 21.9139 8.05801C21.942 8.14238 21.9232 8.23613 21.8623 8.29707L20.967 9.21113L21.1592 10.4111C21.1732 10.4955 21.1404 10.5799 21.0701 10.6314C21.0045 10.683 20.9107 10.6924 20.8357 10.6596L19.7014 10.158L18.6561 10.7533C18.6186 10.7768 18.5811 10.7861 18.5389 10.7861ZM18.2248 8.39082L18.8951 9.08926C18.9467 9.14082 18.9654 9.21113 18.9561 9.28145L18.8342 10.1158L19.5701 9.69863C19.6357 9.66113 19.7107 9.66113 19.7764 9.68926L20.6295 10.0643L20.4842 9.16895C20.4748 9.09863 20.4982 9.02363 20.5451 8.97207L21.1826 8.32051L20.3482 8.24082C20.2779 8.23613 20.2123 8.19395 20.1748 8.13301L19.6967 7.34551L19.317 8.07676C19.2842 8.1377 19.2279 8.17988 19.1576 8.19395L18.2248 8.39082Z"
          fill={fill}
        />
        <path
          d="M19.4343 12.4031C18.4686 12.4031 17.5311 12.014 16.8702 11.2734C15.8202 10.0874 15.7452 8.30619 16.6921 6.93275C16.7624 6.82963 16.9077 6.8015 17.0108 6.87182C17.1139 6.94213 17.1421 7.08744 17.0718 7.19057C16.2468 8.38588 16.3077 9.93744 17.2171 10.964C18.1874 12.0515 19.8374 12.2531 21.1452 11.4468C21.253 11.3812 21.3936 11.414 21.4639 11.5218C21.5296 11.6296 21.4968 11.7703 21.3889 11.8406C20.7749 12.2203 20.0952 12.4031 19.4343 12.4031Z"
          fill={fill}
        />
        <path
          d="M18.3515 13.4393C18.2765 13.4393 18.2062 13.4393 18.1312 13.4346C17.2124 13.3784 16.378 12.9799 15.7827 12.3049C14.5124 10.8706 14.7093 8.60649 16.2187 7.26587C16.4062 7.1018 16.5843 6.97055 16.7624 6.86743C16.8749 6.8018 17.0155 6.8393 17.0765 6.94712C17.1421 7.05493 17.1046 7.20024 16.9968 7.26118C16.8421 7.35024 16.6874 7.46743 16.5233 7.60805C15.2015 8.77993 15.0233 10.7487 16.1249 11.9956C16.6405 12.5768 17.3577 12.9237 18.1546 12.9706C19.0218 13.0221 19.8608 12.7221 20.5312 12.1315C20.7374 11.9487 20.9202 11.7424 21.0749 11.5174C21.1452 11.4143 21.2905 11.3862 21.3937 11.4565C21.4968 11.5268 21.5249 11.6721 21.4546 11.7752C21.2765 12.0331 21.0702 12.2674 20.8358 12.4737C20.1374 13.1018 19.2608 13.4393 18.3515 13.4393Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_317_436">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ActivityLogIcon = ({ fill = 'white' }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.9397 11.3835H11.8764C11.5212 11.3835 11.166 11.5257 10.8819 11.8098L8.25301 14.4387C7.96861 14.7228 7.96861 15.1494 8.25301 15.4335L10.8819 18.0624C11.166 18.3465 11.5215 18.4887 11.8764 18.4887H26.9397C27.366 18.4887 27.6501 18.2046 27.6501 17.7783V12.0939C27.6501 11.6679 27.366 11.3835 26.9397 11.3835ZM3.49231 26.8935V27.7257H4.91341V26.8935C4.45361 27.0558 3.95211 27.0558 3.49231 26.8935ZM3.49231 16.9458V22.8735C3.95211 22.7112 4.45361 22.7112 4.91341 22.8735V16.9458C4.45372 17.1087 3.952 17.1087 3.49231 16.9458ZM4.91341 2.97898V2.14648H3.49231V2.97898C3.72057 2.89835 3.96092 2.85726 4.20301 2.85748C4.44501 2.85713 4.68528 2.89823 4.91341 2.97898ZM4.20301 7.12018C3.96091 7.12032 3.72055 7.07912 3.49231 6.99838V12.9264C3.95201 12.7635 4.45371 12.7635 4.91341 12.9264V6.99838C4.6853 7.07924 4.44503 7.12043 4.20301 7.12018Z"
        fill={fill}
      />
      <path
        d="M4.91339 6.99846C5.43932 6.80464 5.86776 6.4115 6.10596 5.90413C6.34416 5.39676 6.37296 4.81599 6.18612 4.28755C5.99928 3.7591 5.61184 3.3255 5.10767 3.08061C4.6035 2.83571 4.02316 2.79923 3.49229 2.97906C2.96637 3.17287 2.53793 3.56602 2.29973 4.07338C2.06153 4.58075 2.03273 5.16152 2.21956 5.68997C2.4064 6.21841 2.79384 6.65201 3.29801 6.89691C3.80218 7.1418 4.38252 7.17828 4.91339 6.99846ZM3.49229 12.9265C2.96637 13.1203 2.53793 13.5134 2.29973 14.0208C2.06153 14.5282 2.03273 15.1089 2.21956 15.6374C2.4064 16.1658 2.79384 16.5994 3.29801 16.8443C3.80218 17.0892 4.38252 17.1257 4.91339 16.9459C5.43932 16.752 5.86776 16.3589 6.10596 15.8515C6.34416 15.3442 6.37296 14.7634 6.18612 14.2349C5.99928 13.7065 5.61184 13.2729 5.10767 13.028C4.6035 12.7831 4.02316 12.7466 3.49229 12.9265ZM3.49229 22.8736C3.07682 23.0207 2.71714 23.2929 2.46275 23.6528C2.20837 24.0127 2.07178 24.4427 2.07178 24.8834C2.07178 25.3242 2.20837 25.7541 2.46275 26.114C2.71714 26.4739 3.07682 26.7462 3.49229 26.8933C3.95209 27.0555 4.45359 27.0555 4.91339 26.8933C5.32887 26.7462 5.68854 26.4739 5.94293 26.114C6.19732 25.7541 6.33391 25.3242 6.33391 24.8834C6.33391 24.4427 6.19732 24.0127 5.94293 23.6528C5.68854 23.2929 5.32887 23.0207 4.91339 22.8736C4.68523 22.7929 4.44498 22.7518 4.20299 22.7521C3.95369 22.7521 3.71459 22.795 3.49229 22.8736ZM21.2556 21.331H11.8764C11.5212 21.331 11.166 21.4732 10.8819 21.7573L8.25299 24.3865C7.96859 24.6706 7.96859 25.0969 8.25299 25.381L10.8819 28.0102C11.166 28.2943 11.5215 28.4365 11.8764 28.4365H21.2556C21.6819 28.4365 21.966 28.1524 21.966 27.7261V22.0417C21.966 21.6151 21.6816 21.331 21.2556 21.331ZM10.8816 8.11506C11.1657 8.39946 11.5212 8.54166 11.8761 8.54166H21.966C22.3923 8.54166 22.6764 8.25726 22.6764 7.83096V2.14656C22.6764 1.72026 22.3923 1.43616 21.966 1.43616H11.8764C11.5212 1.43616 11.166 1.57836 10.8819 1.86246L8.25299 4.49166C7.96859 4.77576 7.96859 5.20206 8.25299 5.48616L10.8816 8.11506Z"
        fill={fill}
      />
    </svg>
  );
};
export const ArrowDownIcon = ({ fill = 'white' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.293 22.707C11.4805 22.8945 11.7348 22.9998 12 22.9998C12.2652 22.9998 12.5195 22.8945 12.707 22.707L18.707 16.707C18.8892 16.5184 18.99 16.2658 18.9877 16.0036C18.9854 15.7414 18.8802 15.4906 18.6948 15.3052C18.5094 15.1198 18.2586 15.0146 17.9964 15.0123C17.7342 15.01 17.4816 15.1108 17.293 15.293L13 19.586V2C13 1.73478 12.8947 1.48043 12.7071 1.29289C12.5196 1.10536 12.2652 1 12 1C11.7348 1 11.4804 1.10536 11.2929 1.29289C11.1054 1.48043 11 1.73478 11 2V19.586L6.70701 15.293C6.51841 15.1108 6.26581 15.01 6.00361 15.0123C5.74141 15.0146 5.4906 15.1198 5.30519 15.3052C5.11978 15.4906 5.01461 15.7414 5.01234 16.0036C5.01006 16.2658 5.11085 16.5184 5.29301 16.707L11.293 22.707Z"
        fill={fill}
      />
    </svg>
  );
};
export const ArrowRightIcon = ({ fill = 'white' }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.00021 13L18.5862 13L13.2932 18.293C13.1987 18.3855 13.1234 18.4958 13.0718 18.6176C13.0201 18.7393 12.9932 18.8701 12.9924 19.0024C12.9917 19.1347 13.0172 19.2658 13.0675 19.3881C13.1178 19.5104 13.1918 19.6216 13.2854 19.7151C13.3789 19.8086 13.4901 19.8826 13.6124 19.9329C13.7347 19.9832 13.8658 20.0087 13.9981 20.0079C14.1304 20.0071 14.2612 19.9802 14.3829 19.9285C14.5047 19.8769 14.615 19.8016 14.7075 19.707L21.7075 12.707C21.8949 12.5195 22.0002 12.2652 22.0002 12C22.0002 11.7348 21.8949 11.4805 21.7075 11.293L14.7075 4.293C14.6147 4.19996 14.5045 4.12618 14.3831 4.07589C14.2617 4.02561 14.1316 3.99982 14.0002 4C13.8025 4.00004 13.6092 4.05871 13.4447 4.1686C13.2803 4.27848 13.1522 4.43465 13.0765 4.61735C13.0009 4.80005 12.9811 5.00108 13.0196 5.19503C13.0582 5.38899 13.1534 5.56715 13.2932 5.707L18.5862 11L3.00021 11C2.73499 11 2.48064 11.1054 2.2931 11.2929C2.10556 11.4804 2.00021 11.7348 2.00021 12C2.00021 12.2652 2.10556 12.5196 2.2931 12.7071C2.48064 12.8946 2.73499 13 3.00021 13Z"
        fill={fill}
      />
    </svg>
  );
};
export const SpinnerIcon = styled.div`
  ${(props) =>
    props.fill &&
    css`
      border: 4px solid ${props?.fill?.borderColor};
      border-top: 4px ${props?.fill?.borderTopColor} solid;
    `}

  border-radius: 50%;
  height: 30px;
  width: 30px;
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;

export const SendIcon = ({ fill = 'white', size = 30 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.79688 14.3437L10.1719 26.4375L30 4.45312L9.79688 14.3437Z"
        fill={fill}
      />
      <path d="M0 5.25L9.42188 13.4531L29.6719 3.5625L0 5.25Z" fill={fill} />
    </svg>
  );
};

export const ModifyIcon = ({ fill = '#3737D2' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4001 7.33986L16.6601 4.59986C16.3024 4.26395 15.8338 4.07122 15.3434 4.05831C14.8529 4.0454 14.3748 4.21323 14.0001 4.52986L5.00005 13.5299C4.67682 13.8558 4.47556 14.2831 4.43005 14.7399L4.00005 18.9099C3.98658 19.0563 4.00559 19.204 4.05571 19.3422C4.10584 19.4805 4.18585 19.606 4.29005 19.7099C4.38349 19.8025 4.49431 19.8759 4.61615 19.9256C4.73798 19.9754 4.86845 20.0006 5.00005 19.9999H5.09005L9.26005 19.6199C9.71685 19.5744 10.1441 19.3731 10.4701 19.0499L19.4701 10.0499C19.8194 9.68083 20.0082 9.18837 19.995 8.68039C19.9819 8.17242 19.768 7.69037 19.4001 7.33986ZM16.0001 10.6799L13.3201 7.99986L15.2701 5.99986L18.0001 8.72986L16.0001 10.6799Z"
        fill={fill}
      />
    </svg>
  );
};

export const DeleteIcon = ({ fill = '#FF0000' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1499 9.14447L17.8499 18.2247C17.8243 19.0024 17.4967 19.7395 16.9366 20.2796C16.3765 20.8197 15.628 21.1202 14.8499 21.1175H9.1499C8.37232 21.1203 7.62421 20.8201 7.06418 20.2807C6.50415 19.7412 6.17622 19.0049 6.1499 18.2277L5.8499 9.14447C5.84333 8.94556 5.91606 8.75218 6.05207 8.60689C6.18808 8.4616 6.37624 8.37628 6.57515 8.36972C6.77406 8.36315 6.96743 8.43588 7.11273 8.57189C7.25802 8.7079 7.34333 8.89606 7.3499 9.09497L7.6499 18.1775C7.66484 18.5652 7.82944 18.9321 8.10914 19.201C8.38885 19.4699 8.76188 19.62 9.1499 19.6197H14.8499C15.2384 19.62 15.6119 19.4695 15.8917 19.1999C16.1714 18.9303 16.3357 18.5627 16.3499 18.1745L16.6499 9.09497C16.6565 8.89606 16.7418 8.7079 16.8871 8.57189C17.0324 8.43588 17.2257 8.36315 17.4246 8.36972C17.6236 8.37628 17.8117 8.4616 17.9477 8.60689C18.0837 8.75218 18.1565 8.94556 18.1499 9.14447ZM19.1421 6.12272C19.1421 6.32163 19.0631 6.5124 18.9225 6.65305C18.7818 6.7937 18.5911 6.87272 18.3921 6.87272H5.6084C5.40949 6.87272 5.21872 6.7937 5.07807 6.65305C4.93742 6.5124 4.8584 6.32163 4.8584 6.12272C4.8584 5.92381 4.93742 5.73304 5.07807 5.59239C5.21872 5.45174 5.40949 5.37272 5.6084 5.37272H7.9334C8.17103 5.37336 8.40041 5.28556 8.57688 5.12642C8.75336 4.96727 8.86431 4.74816 8.88815 4.51172C8.94349 3.95708 9.20334 3.44292 9.61707 3.0694C10.0308 2.69588 10.5688 2.48977 11.1261 2.49122H12.8736C13.431 2.48977 13.969 2.69588 14.3827 3.0694C14.7965 3.44292 15.0563 3.95708 15.1116 4.51172C15.1355 4.74816 15.2464 4.96727 15.4229 5.12642C15.5994 5.28556 15.8288 5.37336 16.0664 5.37272H18.3914C18.5903 5.37272 18.7811 5.45174 18.9217 5.59239C19.0624 5.73304 19.1414 5.92381 19.1414 6.12272H19.1421ZM10.1901 5.37272H13.8111C13.7126 5.14753 13.6481 4.90891 13.6199 4.66472C13.6013 4.47985 13.5148 4.30846 13.377 4.18375C13.2393 4.05905 13.0602 3.9899 12.8744 3.98972H11.1269C10.9411 3.9899 10.762 4.05905 10.6242 4.18375C10.4865 4.30846 10.4 4.47985 10.3814 4.66472C10.3529 4.90895 10.289 5.14757 10.1901 5.37272ZM10.9454 16.736V10.3497C10.9454 10.1508 10.8664 9.96004 10.7257 9.81939C10.5851 9.67874 10.3943 9.59972 10.1954 9.59972C9.99649 9.59972 9.80572 9.67874 9.66507 9.81939C9.52442 9.96004 9.4454 10.1508 9.4454 10.3497V16.739C9.4454 16.9379 9.52442 17.1286 9.66507 17.2693C9.80572 17.41 9.99649 17.489 10.1954 17.489C10.3943 17.489 10.5851 17.41 10.7257 17.2693C10.8664 17.1286 10.9454 16.9379 10.9454 16.739V16.736ZM14.5559 16.736V10.3497C14.5559 10.1508 14.4769 9.96004 14.3362 9.81939C14.1956 9.67874 14.0048 9.59972 13.8059 9.59972C13.607 9.59972 13.4162 9.67874 13.2756 9.81939C13.1349 9.96004 13.0559 10.1508 13.0559 10.3497V16.739C13.0559 16.9379 13.1349 17.1286 13.2756 17.2693C13.4162 17.41 13.607 17.489 13.8059 17.489C14.0048 17.489 14.1956 17.41 14.3362 17.2693C14.4769 17.1286 14.5559 16.9379 14.5559 16.739V16.736Z"
        fill={fill}
      />
    </svg>
  );
};

export const RefreshIcon = ({
  size = 24,
  stroke = 'currentColor', // couleur du trait
  strokeWidth = 2, // épaisseur du trait
  bg = null, // couleur de fond (ex: '#222' ou 'var(--ds-base)'), null = pas de fond
  radius = 4, // arrondi du fond
  className,
  style,
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      {...rest}
    >
      {/* FOND */}
      {bg && <rect x="0" y="0" width="24" height="24" rx={radius} fill={bg} />}

      {/* Icône Tabler (trait uniquement) */}
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5" fill="none" />
    </svg>
  );
};

export const AllOptionsIcon = ({ fill = '#008000' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-target"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill={'none'} />
      <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
      <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    </svg>
  );
};

export const CreateIcon = ({ fill = '#008000' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_336_38)">
        <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_336_38">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ModifiedLogIcon = (fill = '#333333') => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-pencil"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill={fill} />
      <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
      <path d="M13.5 6.5l4 4" />
    </svg>
  );
};

export const CreatedLogIcon = (fill = '#333333') => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-pencil-plus"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill={fill} />
      <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
      <path d="M13.5 6.5l4 4" />
      <path d="M16 19h6" />
      <path d="M19 16v6" />
    </svg>
  );
};

export const ModifiedLogIcon2 = (fill = '#333333') => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-edit"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill={fill} />
      <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
      <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
      <path d="M16 5l3 3" />
    </svg>
  );
};

export const CalendarLogIcon = (fill = '#333333') => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-calendar-week"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill={fill} />
      <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
      <path d="M16 3v4" />
      <path d="M8 3v4" />
      <path d="M4 11h16" />
      <path d="M7 14h.013" />
      <path d="M10.01 14h.005" />
      <path d="M13.01 14h.005" />
      <path d="M16.015 14h.005" />
      <path d="M13.015 17h.005" />
      <path d="M7.01 17h.005" />
      <path d="M10.01 17h.005" />
    </svg>
  );
};

export const RefreshLogIcon = (fill = '#333333') => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-refresh"
    >
      <path stroke="none" d="M0 0h24v24H0z" />
      <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" fill={fill} />
      <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" fill={fill} />
    </svg>
  );
};

export const ChildLogIcon = (fill = '#333333', stroke = 'currentColor') => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-binary-tree-2"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill={'none'} />
      <path d="M14 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
      <path d="M7 14a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
      <path d="M21 14a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
      <path d="M14 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
      <path d="M12 8v8" />
      <path d="M6.316 12.496l4.368 -4.992" />
      <path d="M17.684 12.496l-4.366 -4.99" />
    </svg>
  );
};

export const CommentIcon = ({ fill = '#808080' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_336_50)">
        <path
          d="M17.3333 17.3333H14.6667C14.2667 17.3333 14 17.0667 14 16.6667C14 16.2667 14.2667 16 14.6667 16H17.3333C18.0667 16 18.6667 15.4 18.6667 14.6667V6.66667C18.6667 5.93333 18.0667 5.33333 17.3333 5.33333H6.66667C5.93333 5.33333 5.33333 5.93333 5.33333 6.66667V14.6667C5.33333 15.4 5.93333 16 6.66667 16H9.33333C9.73333 16 10 16.2667 10 16.6667C10 17.0667 9.73333 17.3333 9.33333 17.3333H6.66667C5.2 17.3333 4 16.1333 4 14.6667V6.66667C4 5.2 5.2 4 6.66667 4H17.3333C18.8 4 20 5.2 20 6.66667V14.6667C20 16.1333 18.8 17.3333 17.3333 17.3333Z"
          fill={fill}
        />
        <path
          d="M11.9999 19.9997C11.7999 19.9997 11.6666 19.933 11.5333 19.7997L8.86659 17.133C8.59992 16.8663 8.59992 16.4663 8.86659 16.1997C9.13325 15.933 9.53325 15.933 9.79992 16.1997L11.9999 18.3997L14.1999 16.1997C14.4666 15.933 14.8666 15.933 15.1333 16.1997C15.3999 16.4663 15.3999 16.8663 15.1333 17.133L12.4666 19.7997C12.3333 19.933 12.1999 19.9997 11.9999 19.9997ZM15.9999 8.66634H7.99992C7.59992 8.66634 7.33325 8.39967 7.33325 7.99967C7.33325 7.59967 7.59992 7.33301 7.99992 7.33301H15.9999C16.3999 7.33301 16.6666 7.59967 16.6666 7.99967C16.6666 8.39967 16.3999 8.66634 15.9999 8.66634ZM12.6666 11.333H7.99992C7.59992 11.333 7.33325 11.0663 7.33325 10.6663C7.33325 10.2663 7.59992 9.99967 7.99992 9.99967H12.6666C13.0666 9.99967 13.3333 10.2663 13.3333 10.6663C13.3333 11.0663 13.0666 11.333 12.6666 11.333ZM14.6666 13.9997H7.99992C7.59992 13.9997 7.33325 13.733 7.33325 13.333C7.33325 12.933 7.59992 12.6663 7.99992 12.6663H14.6666C15.0666 12.6663 15.3333 12.933 15.3333 13.333C15.3333 13.733 15.0666 13.9997 14.6666 13.9997Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_336_50">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MeIcon = ({ fill = '#808080' }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_127_11)">
        <path
          d="M20.7 1.5H5.3C3.2 1.5 1.5 3.2 1.5 5.3V20.7C1.5 22.8 3.2 24.5 5.3 24.5H20.7C22.8 24.5 24.5 22.8 24.5 20.7V5.3C24.5 3.2 22.8 1.5 20.7 1.5ZM13.5 16.4C13.5 16.7 13.3 16.9 13 16.9C12.7 16.9 12.5 16.7 12.5 16.4V11.6C12.5 10.8 11.8 10.1 11 10.1C10.2 10.1 9.5 10.8 9.5 11.6V16.4C9.5 16.7 9.3 16.9 9 16.9C8.7 16.9 8.5 16.7 8.5 16.4V11.6C8.5 10.8 7.8 10.1 7 10.1C6.2 10.1 5.5 10.8 5.5 11.6V16.4C5.5 16.7 5.3 16.9 5 16.9C4.7 16.9 4.5 16.7 4.5 16.4V9.6C4.5 9.3 4.7 9.1 5 9.1C5.3 9.1 5.5 9.3 5.5 9.6V9.7C5.9 9.4 6.4 9.2 7 9.2C7.8 9.2 8.5 9.6 9 10.2C9.4 9.6 10.2 9.2 11 9.2C12.3 9.2 13.4 10.3 13.4 11.6V16.4H13.5ZM21.1 13C21 13.1 20.9 13.2 20.7 13.2H16.8C16.5 13.2 16.3 13 16.3 12.7C16.3 12.4 16.5 12.2 16.8 12.2H20.1C20 11.8 19.7 11.4 19.4 11.1C18.3 10 16.5 10 15.4 11.1C14.3 12.2 14.3 14 15.4 15.1C16.5 16.2 18.3 16.2 19.4 15.1C19.6 14.9 19.7 14.7 19.9 14.5C20 14.3 20.3 14.2 20.6 14.3C20.8 14.4 20.9 14.7 20.8 15C20.6 15.4 20.4 15.6 20.2 15.9C19.5 16.6 18.5 17 17.5 17C16.5 17 15.6 16.6 14.8 15.9C13.3 14.4 13.3 12 14.8 10.6C16.3 9.1 18.7 9.1 20.1 10.6C20.7 11.2 21.1 11.9 21.2 12.8C21.3 12.8 21.2 12.9 21.1 13Z"
          fill="#FFD4C7"
        />
      </g>
      <defs>
        <clipPath id="clip0_127_11">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DownloadIcon = ({ fill = '#808080' }) => {
  return (
    <svg
      id="bold"
      enableBackground="new 0 0 24 24"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        d="m12 16c-.205 0-.401-.084-.542-.232l-5.25-5.5c-.455-.476-.117-1.268.542-1.268h2.75v-5.75c0-.689.561-1.25 1.25-1.25h2.5c.689 0 1.25.561 1.25 1.25v5.75h2.75c.659 0 .997.792.542 1.268l-5.25 5.5c-.141.148-.337.232-.542.232z"
      />
      <path
        fill={fill}
        d="m22.25 22h-20.5c-.965 0-1.75-.785-1.75-1.75v-.5c0-.965.785-1.75 1.75-1.75h20.5c.965 0 1.75.785 1.75 1.75v.5c0 .965-.785 1.75-1.75 1.75z"
      />
    </svg>
  );
};

export const XlSXIcon = ({ fill = '#808080' }) => {
  return (
    <svg
      clipRule="evenodd"
      fillRule="evenodd"
      height="512"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      viewBox="0 0 267 267"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="m50 154.167c56.944 9.876 113.889 9.544 170.833 0v-79.167c0-.902-.292-1.779-.833-2.5l-37.5-50c-.787-1.049-2.022-1.667-3.333-1.667h-116.667c-3.315 0-6.495 1.317-8.839 3.661-2.344 2.345-3.661 5.524-3.661 8.839v95.834c0 6.188-1.451 11.433-1.451 15.614 0 5.78 1.451 9.386 1.451 9.386z"
          fill="#d8dfe3"
        />
        <path
          d="m25 143.365v89.968c0 3.315 1.317 6.495 3.661 8.839s5.524 3.661 8.839 3.661h191.667c3.315 0 6.494-1.317 8.839-3.661 2.344-2.344 3.661-5.524 3.661-8.839 0-15.966 0-50.7 0-66.666 0-3.315-1.317-6.495-3.661-8.839-2.345-2.344-5.524-3.661-8.839-3.661h-187.5c-5.316 0-16.667-10.802-16.667-10.802z"
          fill="#1fb35b"
        />
        <path
          d="m37.5 154.167c-3.804 0-6.581-1.543-8.625-3.443-1.923-1.788-3.875-4.939-3.875-9.057 0-2.643 1.317-6.495 3.661-8.839s5.524-3.661 8.839-3.661h12.5v25s1.071 0-12.5 0z"
          fill="#198043"
        />
        <path
          d="m129.167 137.5v-37.5h-54.167v33.333c0 2.302 1.865 4.167 4.167 4.167z"
          fill="#1fb35b"
        />
        <path
          d="m129.167 54.167h-50c-2.302 0-4.167 1.865-4.167 4.166v33.334h54.167z"
          fill="#1fb35b"
        />
        <path
          d="m191.667 100h-54.167v37.5h50c2.301 0 4.167-1.865 4.167-4.167z"
          fill="#1fb35b"
        />
        <path
          d="m179.167 54.167h-41.667v37.5h54.167v-16.667c0-2.3-1.867-4.167-4.167-4.167s-4.167-10.2-4.167-12.5c0-2.299-1.867-4.166-4.166-4.166z"
          fill="#1fb35b"
        />
        <g fill="#d8dfe3">
          <path d="m97.396 179.167v41.666c0 2.302 1.865 4.167 4.167 4.167h26.041c2.3 0 4.167-1.867 4.167-4.167 0-2.299-1.867-4.166-4.167-4.166h-21.875v-37.5c0-2.3-1.867-4.167-4.166-4.167-2.3 0-4.167 1.867-4.167 4.167z" />
          <path d="m180.74 223.577 36.458-41.667c1.515-1.73 1.339-4.365-.392-5.879-1.73-1.514-4.365-1.339-5.879.392l-36.459 41.667c-1.514 1.73-1.338 4.365.392 5.879 1.731 1.514 4.366 1.339 5.88-.392z" />
          <path d="m55.74 223.577 36.458-41.667c1.515-1.73 1.339-4.365-.392-5.879-1.73-1.514-4.365-1.339-5.879.392l-36.459 41.667c-1.514 1.73-1.338 4.365.392 5.879 1.731 1.514 4.366 1.339 5.88-.392z" />
          <path d="m217.198 218.09-36.458-41.667c-1.514-1.731-4.149-1.906-5.88-.392-1.73 1.514-1.906 4.149-.392 5.879l36.459 41.667c1.514 1.731 4.149 1.906 5.879.392 1.731-1.514 1.907-4.149.392-5.879z" />
          <path d="m92.198 218.09-36.458-41.667c-1.514-1.731-4.149-1.906-5.88-.392-1.73 1.514-1.906 4.149-.392 5.879l36.459 41.667c1.514 1.731 4.149 1.906 5.879.392 1.731-1.514 1.907-4.149.392-5.879z" />
          <path d="m133.855 210.443-.001-.001v2.066c0 3.313 1.316 6.491 3.659 8.833 2.343 2.343 5.52 3.659 8.833 3.659h9.391c3.313 0 6.491-1.316 8.833-3.659 2.343-2.342 3.659-5.52 3.659-8.833 0-.56 0-1.116 0-1.658 0-5.111-3.112-9.707-7.857-11.606l-15.151-6.06c-1.832-.733-3.034-2.507-3.034-4.48v-1.204c0-1.105.439-2.165 1.221-2.946.781-.782 1.841-1.221 2.946-1.221h9.375c1.105 0 2.165.439 2.946 1.221.782.781 1.221 1.841 1.221 2.946v2.058c0 1.176.52 2.24 1.042 2.78.814.923 1.982 1.412 3.124 1.412 2.029 0 4.167-1.566 4.167-4.192v-2.058c0-3.315-1.317-6.495-3.661-8.839s-5.524-3.661-8.839-3.661h-9.375c-3.315 0-6.495 1.317-8.839 3.661s-3.661 5.524-3.661 8.839v1.204c0 5.38 3.276 10.219 8.272 12.217l15.151 6.061c1.582.632 2.619 2.165 2.619 3.868v1.658c0 1.103-.438 2.161-1.218 2.941s-1.838 1.218-2.941 1.218h-9.391c-1.103 0-2.161-.438-2.941-1.218-.779-.78-1.217-1.838-1.217-2.94-.001-.001-.001-.001-.001-2.067 0-2.748-2.239-4.194-4.093-4.194-1.758 0-4.24 1.363-4.24 4.169 0 .026.001.026.001.026z" />
        </g>
        <path
          d="m179.167 20.833v41.667c0 3.315 1.317 6.495 3.661 8.839s5.523 3.661 8.839 3.661h29.166c0-.902-.292-1.779-.833-2.5l-37.5-50c-.787-1.049-2.022-1.667-3.333-1.667z"
          fill="#afbdc7"
        />
      </g>
    </svg>
  );
};

export const DOCXIcon = ({ fill = '#808080' }) => {
  return (
    <svg
      clipRule="evenodd"
      fillRule="evenodd"
      height="512"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      viewBox="0 0 267 267"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="m50 154.167c56.944 9.876 113.889 9.544 170.833 0v-79.167c0-.902-.292-1.779-.833-2.5l-37.5-50c-.787-1.049-2.022-1.667-3.333-1.667h-116.667c-3.315 0-6.495 1.317-8.839 3.661-2.344 2.345-3.661 5.524-3.661 8.839v95.834c0 6.188-1.451 11.433-1.451 15.614 0 5.78 1.451 9.386 1.451 9.386z"
          fill="#d8dfe3"
        />
        <path
          d="m25 143.365v89.968c0 3.315 1.317 6.495 3.661 8.839s5.524 3.661 8.839 3.661h191.667c3.315 0 6.494-1.317 8.839-3.661 2.344-2.344 3.661-5.524 3.661-8.839 0-15.966 0-50.7 0-66.666 0-3.315-1.317-6.495-3.661-8.839-2.345-2.344-5.524-3.661-8.839-3.661h-187.5c-5.316 0-16.667-10.802-16.667-10.802z"
          fill="#2d98db"
        />
        <path
          d="m37.5 154.167c-3.804 0-6.581-1.543-8.625-3.443-1.923-1.788-3.875-4.939-3.875-9.057 0-2.643 1.317-6.495 3.661-8.839s5.524-3.661 8.839-3.661h12.5v25s1.071 0-12.5 0z"
          fill="#216896"
        />
        <path
          d="m179.167 20.833v41.667c0 3.315 1.317 6.495 3.661 8.839s5.523 3.661 8.839 3.661h29.166c0-.902-.292-1.779-.833-2.5l-37.5-50c-.787-1.049-2.022-1.667-3.333-1.667z"
          fill="#afbdc7"
        />
        <path
          d="m87.5 75h54.167"
          fill="none"
          stroke="#000"
          strokeWidth="8.33"
        />
        <path
          d="m87.5 100h95.833"
          fill="none"
          stroke="#000"
          strokeWidth="8.33"
        />
        <path
          d="m87.5 125h95.833"
          fill="none"
          stroke="#000"
          strokeWidth="8.33"
        />
        <g fill="#d8dfe3">
          <path d="m82.988 195.833c0-5.525-2.195-10.824-6.102-14.731s-9.206-6.102-14.731-6.102c-7.45 0-14.583 0-14.583 0-2.302 0-4.167 1.865-4.167 4.167v41.666c0 2.302 1.865 4.167 4.167 4.167h14.583c5.525 0 10.824-2.195 14.731-6.102s6.102-9.206 6.102-14.731zm-8.333 0v8.334c0 3.315-1.317 6.494-3.661 8.839-2.344 2.344-5.524 3.661-8.839 3.661h-10.417v-33.334h10.417c3.315 0 6.495 1.317 8.839 3.661 2.344 2.345 3.661 5.524 3.661 8.839z" />
          <path d="m156.832 175.414h-2.382c-11.506 0-20.833 9.327-20.833 20.833v8.334c0 11.506 9.327 20.833 20.833 20.833h2.382c7.432 0 14.182-4.336 17.272-11.096.431-.942.793-1.734.793-1.734s-3.78 2.413-3.78 2.413c-1.646-5.966-3.071-6.704-3.747-5.797l-.052-.081s-.793 1.734-.793 1.734c-1.734 3.794-5.522 6.228-9.693 6.228h-2.381c-6.904 0-12.501-5.597-12.501-12.5v-8.334c0-6.903 5.597-12.5 12.5-12.5h2.382c4.171 0 7.959 2.434 9.693 6.227 0 0 .793 1.735.793 1.735l.011.023.033.071.054.106.022.046.017.031c1.283 2.423 3.662 2.178 3.662 2.178l.242-.081c1.066-.383 5.226-2.146 3.538-5.839l-.793-1.734c-3.09-6.76-9.84-11.096-17.272-11.096z" />
          <path d="m108.508 175c-11.22 0-20.834 10.975-20.834 25s9.614 25 20.834 25 20.833-10.975 20.833-25-9.613-25-20.833-25zm0 8.333c7.183 0 12.5 7.688 12.5 16.667s-5.317 16.667-12.5 16.667-12.5-7.688-12.5-16.667 5.317-16.667 12.5-16.667z" />
          <path d="m185.772 223.577 36.459-41.667c1.514-1.73 1.338-4.365-.392-5.879-1.731-1.514-4.365-1.339-5.88.392l-36.458 41.667c-1.514 1.73-1.339 4.365.392 5.879s4.365 1.339 5.879-.392z" />
          <path d="m222.231 218.09-36.459-41.667c-1.514-1.731-4.148-1.906-5.879-.392s-1.906 4.149-.392 5.879l36.458 41.667c1.515 1.731 4.149 1.906 5.88.392 1.73-1.514 1.906-4.149.392-5.879z" />
        </g>
      </g>
    </svg>
  );
};

export const AddIcon = ({ fillFrom = '#55D6FF', fillTo = '#CE55FF' }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_127_2)">
        <path
          d="M19.5861 16.7313C19.5861 16.9281 19.5079 17.117 19.3687 17.2562C19.2295 17.3955 19.0406 17.4737 18.8438 17.4738H13.9723V22.3449C13.9723 22.5419 13.8941 22.7308 13.7548 22.87C13.6156 23.0093 13.4267 23.0875 13.2298 23.0875C13.0328 23.0875 12.844 23.0093 12.7047 22.87C12.5654 22.7308 12.4872 22.5419 12.4872 22.3449V17.4738H7.61607C7.41914 17.4738 7.23026 17.3956 7.09101 17.2563C6.95175 17.1171 6.87352 16.9282 6.87352 16.7313C6.87352 16.5343 6.95175 16.3454 7.09101 16.2062C7.23026 16.0669 7.41914 15.9887 7.61607 15.9887H12.4872V11.1175C12.4872 10.9206 12.5654 10.7317 12.7047 10.5924C12.844 10.4532 13.0328 10.3749 13.2298 10.3749C13.4267 10.3749 13.6156 10.4532 13.7548 10.5924C13.8941 10.7317 13.9723 10.9206 13.9723 11.1175V15.9887H18.8438C19.0406 15.9888 19.2295 16.067 19.3687 16.2063C19.5079 16.3455 19.5861 16.5344 19.5861 16.7313ZM30 4.24164V22.2961C29.9987 23.3057 29.6344 24.2812 28.9737 25.0446C28.313 25.8081 27.3998 26.3085 26.4008 26.4547C26.2351 27.4342 25.7281 28.3235 24.9698 28.9652C24.2114 29.6069 23.2504 29.9597 22.257 29.961H4.20258C3.08835 29.9598 2.02009 29.5167 1.23221 28.7288C0.444328 27.9409 0.00117879 26.8727 0 25.7584V7.704C0.00134671 6.69438 0.365596 5.71888 1.0263 4.95547C1.68701 4.19205 2.60014 3.69158 3.59912 3.54537C3.7649 2.56586 4.27184 1.67656 5.03022 1.03486C5.78861 0.393155 6.74955 0.0404163 7.74299 0.0390625H25.7974C26.9117 0.0402413 27.9799 0.48339 28.7678 1.27127C29.5557 2.05915 29.9988 3.12741 30 4.24164ZM24.9744 7.704C24.9737 6.98352 24.6871 6.29275 24.1777 5.78327C23.6682 5.27378 22.9775 4.98719 22.257 4.98637H4.20258C3.48212 4.98719 2.79141 5.27376 2.28197 5.7832C1.77254 6.29265 1.48598 6.98337 1.48518 7.70383V25.7584C1.48598 26.4789 1.77254 27.1696 2.28197 27.6791C2.79141 28.1885 3.48212 28.4751 4.20258 28.4759H22.257C22.9775 28.4751 23.6682 28.1885 24.1776 27.6791C24.6871 27.1696 24.9736 26.4789 24.9744 25.7584V7.704ZM28.5148 4.24164C28.514 3.52118 28.2275 2.83046 27.718 2.32102C27.2086 1.81157 26.5179 1.525 25.7974 1.52418H7.74299C7.15161 1.525 6.57658 1.71842 6.10493 2.07518C5.63327 2.43193 5.29064 2.93259 5.12889 3.50143H22.257C23.3712 3.50262 24.4395 3.94578 25.2273 4.73366C26.0152 5.52153 26.4584 6.58978 26.4595 7.704V24.9317C27.0464 24.7834 27.5671 24.4438 27.9393 23.9665C28.3115 23.4892 28.514 22.9015 28.5148 22.2962V4.24164Z"
          fill="url(#paint0_linear_127_2)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_127_2"
          x1="0"
          y1="15"
          x2="30"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={fillFrom} />
          <stop offset="1" stopColor={fillTo} />
        </linearGradient>
        <clipPath id="clip0_127_2">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RubberIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-rubber-stamp"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M21 17.85h-18c0 -4.05 1.421 -4.05 3.79 -4.05c5.21 0 1.21 -4.59 1.21 -6.8a4 4 0 1 1 8 0c0 2.21 -4 6.8 1.21 6.8c2.369 0 3.79 0 3.79 4.05z"></path>
      <path d="M5 21h14"></path>
    </svg>
  );
};

export const SvgIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-file-type-svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
      <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path>
      <path d="M4 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75"></path>
      <path d="M10 15l2 6l2 -6"></path>
      <path d="M20 15h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1v-3"></path>
    </svg>
  );
};

export const TextIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_213_2)">
        <path
          d="M17.625 3.375H13.125H10.875H6.375H4.125V5.625V7.125H6.375V5.625H10.875V18.375H7.875V20.625H10.875H13.125H16.125V18.375H13.125V5.625H17.625V7.125H19.875V5.625V3.375H17.625Z"
          fill="#8C8891"
        />
        <path
          d="M22.125 24H19.875C19.7756 24 19.6802 23.9605 19.6099 23.8902C19.5396 23.8198 19.5 23.7245 19.5 23.625C19.5 23.5255 19.5396 23.4302 19.6099 23.3598C19.6802 23.2895 19.7756 23.25 19.875 23.25H22.125C22.2314 23.2502 22.3372 23.235 22.4393 23.205C22.5348 23.1771 22.6374 23.1882 22.7247 23.2359C22.812 23.2837 22.8767 23.3641 22.9047 23.4596C22.9326 23.5551 22.9215 23.6578 22.8737 23.745C22.826 23.8323 22.7455 23.8971 22.65 23.925C22.4795 23.9747 22.3027 24 22.125 24ZM17.625 24H15.375C15.2756 24 15.1802 23.9605 15.1099 23.8902C15.0396 23.8198 15 23.7245 15 23.625C15 23.5255 15.0396 23.4302 15.1099 23.3598C15.1802 23.2895 15.2756 23.25 15.375 23.25H17.625C17.7245 23.25 17.8199 23.2895 17.8902 23.3598C17.9605 23.4302 18 23.5255 18 23.625C18 23.7245 17.9605 23.8198 17.8902 23.8902C17.8199 23.9605 17.7245 24 17.625 24ZM13.125 24H10.875C10.7756 24 10.6802 23.9605 10.6099 23.8902C10.5396 23.8198 10.5 23.7245 10.5 23.625C10.5 23.5255 10.5396 23.4302 10.6099 23.3598C10.6802 23.2895 10.7756 23.25 10.875 23.25H13.125C13.2245 23.25 13.3199 23.2895 13.3902 23.3598C13.4605 23.4302 13.5 23.5255 13.5 23.625C13.5 23.7245 13.4605 23.8198 13.3902 23.8902C13.3199 23.9605 13.2245 24 13.125 24ZM8.62505 24H6.37505C6.27559 24 6.18021 23.9605 6.10988 23.8902C6.03956 23.8198 6.00005 23.7245 6.00005 23.625C6.00005 23.5255 6.03956 23.4302 6.10988 23.3598C6.18021 23.2895 6.27559 23.25 6.37505 23.25H8.62505C8.7245 23.25 8.81989 23.2895 8.89021 23.3598C8.96054 23.4302 9.00005 23.5255 9.00005 23.625C9.00005 23.7245 8.96054 23.8198 8.89021 23.8902C8.81989 23.9605 8.7245 24 8.62505 24ZM4.12505 24H1.87505C1.77559 24 1.68021 23.9605 1.60988 23.8902C1.53956 23.8198 1.50005 23.7245 1.50005 23.625C1.50005 23.5255 1.53956 23.4302 1.60988 23.3598C1.68021 23.2895 1.77559 23.25 1.87505 23.25H4.12505C4.2245 23.25 4.31989 23.2895 4.39021 23.3598C4.46054 23.4302 4.50005 23.5255 4.50005 23.625C4.50005 23.7245 4.46054 23.8198 4.39021 23.8902C4.31989 23.9605 4.2245 24 4.12505 24ZM0.375047 22.6072C0.279491 22.6074 0.187469 22.5711 0.117775 22.5058C0.0480804 22.4404 0.00597118 22.3509 4.6875e-05 22.2555C4.6875e-05 22.2097 -0.00445313 22.164 4.6875e-05 22.1175V19.9822C4.6875e-05 19.8828 0.0395557 19.7874 0.109882 19.7171C0.180208 19.6468 0.275591 19.6072 0.375047 19.6072C0.474503 19.6072 0.569886 19.6468 0.640212 19.7171C0.710538 19.7874 0.750047 19.8828 0.750047 19.9822V22.209C0.756206 22.3083 0.722687 22.4059 0.656863 22.4804C0.591039 22.555 0.498301 22.6003 0.399047 22.6065L0.375047 22.6072ZM23.625 22.179C23.5256 22.179 23.4302 22.1395 23.3599 22.0692C23.2896 21.9988 23.25 21.9035 23.25 21.804V19.554C23.25 19.4545 23.2896 19.3592 23.3599 19.2888C23.4302 19.2185 23.5256 19.179 23.625 19.179C23.7245 19.179 23.8199 19.2185 23.8902 19.2888C23.9605 19.3592 24 19.4545 24 19.554V21.804C24 21.9035 23.9605 21.9988 23.8902 22.0692C23.8199 22.1395 23.7245 22.179 23.625 22.179ZM0.375047 18.1072C0.275591 18.1072 0.180208 18.0677 0.109882 17.9974C0.0395557 17.9271 4.6875e-05 17.8317 4.6875e-05 17.7322V15.4822C4.6875e-05 15.3828 0.0395557 15.2874 0.109882 15.2171C0.180208 15.1468 0.275591 15.1072 0.375047 15.1072C0.474503 15.1072 0.569886 15.1468 0.640212 15.2171C0.710538 15.2874 0.750047 15.3828 0.750047 15.4822V17.7322C0.750047 17.8317 0.710538 17.9271 0.640212 17.9974C0.569886 18.0677 0.474503 18.1072 0.375047 18.1072ZM23.625 17.679C23.5256 17.679 23.4302 17.6395 23.3599 17.5692C23.2896 17.4988 23.25 17.4035 23.25 17.304V15.054C23.25 14.9545 23.2896 14.8592 23.3599 14.7888C23.4302 14.7185 23.5256 14.679 23.625 14.679C23.7245 14.679 23.8199 14.7185 23.8902 14.7888C23.9605 14.8592 24 14.9545 24 15.054V17.304C24 17.4035 23.9605 17.4988 23.8902 17.5692C23.8199 17.6395 23.7245 17.679 23.625 17.679ZM0.375047 13.6072C0.275591 13.6072 0.180208 13.5677 0.109882 13.4974C0.0395557 13.4271 4.6875e-05 13.3317 4.6875e-05 13.2322V10.9822C4.6875e-05 10.8828 0.0395557 10.7874 0.109882 10.7171C0.180208 10.6468 0.275591 10.6072 0.375047 10.6072C0.474503 10.6072 0.569886 10.6468 0.640212 10.7171C0.710538 10.7874 0.750047 10.8828 0.750047 10.9822V13.2322C0.750047 13.3317 0.710538 13.4271 0.640212 13.4974C0.569886 13.5677 0.474503 13.6072 0.375047 13.6072ZM23.625 13.179C23.5256 13.179 23.4302 13.1395 23.3599 13.0692C23.2896 12.9988 23.25 12.9035 23.25 12.804V10.554C23.25 10.4545 23.2896 10.3592 23.3599 10.2888C23.4302 10.2185 23.5256 10.179 23.625 10.179C23.7245 10.179 23.8199 10.2185 23.8902 10.2888C23.9605 10.3592 24 10.4545 24 10.554V12.804C24 12.9035 23.9605 12.9988 23.8902 13.0692C23.8199 13.1395 23.7245 13.179 23.625 13.179ZM0.375047 9.10725C0.275591 9.10725 0.180208 9.06774 0.109882 8.99742C0.0395557 8.92709 4.6875e-05 8.83171 4.6875e-05 8.73225V6.48225C4.6875e-05 6.38279 0.0395557 6.28741 0.109882 6.21709C0.180208 6.14676 0.275591 6.10725 0.375047 6.10725C0.474503 6.10725 0.569886 6.14676 0.640212 6.21709C0.710538 6.28741 0.750047 6.38279 0.750047 6.48225V8.73225C0.750047 8.83171 0.710538 8.92709 0.640212 8.99742C0.569886 9.06774 0.474503 9.10725 0.375047 9.10725ZM23.625 8.679C23.5256 8.679 23.4302 8.63949 23.3599 8.56916C23.2896 8.49884 23.25 8.40346 23.25 8.304V6.054C23.25 5.95454 23.2896 5.85916 23.3599 5.78884C23.4302 5.71851 23.5256 5.679 23.625 5.679C23.7245 5.679 23.8199 5.71851 23.8902 5.78884C23.9605 5.85916 24 5.95454 24 6.054V8.304C24 8.40346 23.9605 8.49884 23.8902 8.56916C23.8199 8.63949 23.7245 8.679 23.625 8.679ZM0.375047 4.60725C0.275591 4.60725 0.180208 4.56774 0.109882 4.49742C0.0395557 4.42709 4.6875e-05 4.33171 4.6875e-05 4.23225V1.98225C4.6875e-05 1.88279 0.0395557 1.78741 0.109882 1.71708C0.180208 1.64676 0.275591 1.60725 0.375047 1.60725C0.474503 1.60725 0.569886 1.64676 0.640212 1.71708C0.710538 1.78741 0.750047 1.88279 0.750047 1.98225V4.23225C0.750047 4.33171 0.710538 4.42709 0.640212 4.49742C0.569886 4.56774 0.474503 4.60725 0.375047 4.60725ZM23.625 4.179C23.5256 4.179 23.4302 4.13949 23.3599 4.06916C23.2896 3.99884 23.25 3.90346 23.25 3.804V1.875C23.2493 1.79432 23.2405 1.71392 23.2238 1.635C23.203 1.53763 23.2218 1.436 23.2759 1.35245C23.3301 1.2689 23.4152 1.21029 23.5125 1.1895C23.6099 1.16871 23.7116 1.18746 23.7951 1.24161C23.8786 1.29576 23.9373 1.38088 23.958 1.47825C23.9855 1.60874 23.9995 1.74167 24 1.875V3.804C24 3.90346 23.9605 3.99884 23.8902 4.06916C23.8199 4.13949 23.7245 4.179 23.625 4.179ZM1.6613 0.765C1.56184 0.771862 1.46373 0.738935 1.38855 0.673461C1.31337 0.607988 1.26728 0.515331 1.26042 0.415875C1.25356 0.316419 1.28649 0.21831 1.35196 0.143131C1.41743 0.0679527 1.51009 0.0218625 1.60955 0.015C1.69655 0.006 1.76555 0.0105 1.87505 0H3.9113C4.01075 0 4.10614 0.0395088 4.17646 0.109835C4.24679 0.180161 4.2863 0.275544 4.2863 0.375C4.2863 0.474456 4.24679 0.569839 4.17646 0.640165C4.10614 0.710491 4.01075 0.75 3.9113 0.75H1.87505C1.81955 0.75675 1.7663 0.75 1.71455 0.76125C1.69691 0.763763 1.67911 0.765017 1.6613 0.765ZM21.9113 0.75H19.6613C19.5618 0.75 19.4665 0.710491 19.3961 0.640165C19.3258 0.569839 19.2863 0.474456 19.2863 0.375C19.2863 0.275544 19.3258 0.180161 19.3961 0.109835C19.4665 0.0395088 19.5618 0 19.6613 0L21.9113 0C22.0108 0 22.1061 0.0395088 22.1765 0.109835C22.2468 0.180161 22.2863 0.275544 22.2863 0.375C22.2863 0.474456 22.2468 0.569839 22.1765 0.640165C22.1061 0.710491 22.0108 0.75 21.9113 0.75ZM17.4113 0.75H15.1613C15.0618 0.75 14.9665 0.710491 14.8961 0.640165C14.8258 0.569839 14.7863 0.474456 14.7863 0.375C14.7863 0.275544 14.8258 0.180161 14.8961 0.109835C14.9665 0.0395088 15.0618 0 15.1613 0L17.4113 0C17.5108 0 17.6061 0.0395088 17.6765 0.109835C17.7468 0.180161 17.7863 0.275544 17.7863 0.375C17.7863 0.474456 17.7468 0.569839 17.6765 0.640165C17.6061 0.710491 17.5108 0.75 17.4113 0.75ZM12.9113 0.75H10.6613C10.5618 0.75 10.4665 0.710491 10.3961 0.640165C10.3258 0.569839 10.2863 0.474456 10.2863 0.375C10.2863 0.275544 10.3258 0.180161 10.3961 0.109835C10.4665 0.0395088 10.5618 0 10.6613 0L12.9113 0C13.0108 0 13.1061 0.0395088 13.1765 0.109835C13.2468 0.180161 13.2863 0.275544 13.2863 0.375C13.2863 0.474456 13.2468 0.569839 13.1765 0.640165C13.1061 0.710491 13.0108 0.75 12.9113 0.75ZM8.4113 0.75H6.1613C6.06184 0.75 5.96646 0.710491 5.89613 0.640165C5.82581 0.569839 5.7863 0.474456 5.7863 0.375C5.7863 0.275544 5.82581 0.180161 5.89613 0.109835C5.96646 0.0395088 6.06184 0 6.1613 0L8.4113 0C8.51075 0 8.60614 0.0395088 8.67646 0.109835C8.74679 0.180161 8.7863 0.275544 8.7863 0.375C8.7863 0.474456 8.74679 0.569839 8.67646 0.640165C8.60614 0.710491 8.51075 0.75 8.4113 0.75Z"
          fill="#8C8891"
        />
      </g>
      <defs>
        <clipPath id="clip0_213_2">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ZigzagIcon = () => {
  return (
    <svg
      id="a"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m23 4c0 .5522-.4473 1-1 1h-2c-2.0859 0-3.9619 1.1592-4.8945 3.0249l-4.4219 8.8447c-1.2744 2.5479-3.8354 4.1304-6.6836 4.1304h-2c-.5522 0-1-.4478-1-1s.4478-1 1-1h2c2.0859 0 3.9614-1.1592 4.8945-3.0249l4.4219-8.8447c1.2744-2.5479 3.835-4.1304 6.6836-4.1304h2c.5527 0 1 .4478 1 1z"
        fill="#141E46"
      />
    </svg>
  );
};

export const PolylineIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.01846 19.5586C5.28549 19.5586 5.54915 19.499 5.79025 19.3842C6.03134 19.2694 6.24381 19.1023 6.41219 18.895C6.58056 18.6878 6.70061 18.4456 6.76359 18.1861C6.82657 17.9266 6.83091 17.6563 6.77627 17.3949L8.90346 15.9999C9.25343 16.2484 9.6809 16.3632 10.1083 16.3236C10.5357 16.2839 10.9347 16.0923 11.2329 15.7836C11.5311 15.4748 11.7088 15.0695 11.7337 14.6409C11.7586 14.2124 11.6291 13.7892 11.3686 13.448L14.5561 8.20131C14.7968 8.24337 15.0435 8.23566 15.2811 8.17866C15.5187 8.12166 15.7421 8.01658 15.9375 7.8699L18.0192 9.1613C17.9435 9.57311 18.014 9.99841 18.2185 10.3638C18.4229 10.7292 18.7485 11.0117 19.1391 11.1626C19.5297 11.3135 19.9607 11.3233 20.3577 11.1903C20.7547 11.0573 21.0928 10.7899 21.3137 10.4341C21.5345 10.0784 21.6242 9.65676 21.5673 9.24195C21.5104 8.82713 21.3105 8.4452 21.002 8.1621C20.6935 7.87899 20.2958 7.71248 19.8777 7.69131C19.4595 7.67015 19.0471 7.79565 18.7116 8.04615L16.628 6.75474C16.6821 6.46071 16.662 6.1578 16.5695 5.87351C16.4769 5.58921 16.3148 5.33253 16.098 5.12674C15.8811 4.92095 15.6162 4.77257 15.3275 4.69506C15.0387 4.61755 14.7352 4.61337 14.4444 4.68288C14.1536 4.7524 13.8848 4.89342 13.6623 5.09315C13.4398 5.29288 13.2707 5.545 13.1703 5.82663C13.07 6.10827 13.0415 6.4105 13.0875 6.70592C13.1336 7.00134 13.2526 7.28059 13.4339 7.51834L10.2464 12.7651C9.95782 12.7154 9.66144 12.737 9.38312 12.8281C9.1048 12.9192 8.85298 13.077 8.64961 13.2877C8.44624 13.4984 8.29749 13.7557 8.21632 14.0371C8.13515 14.3185 8.12403 14.6154 8.18393 14.9021L6.05674 16.2971C5.82625 16.1339 5.56051 16.0274 5.28112 15.9863C5.00173 15.9451 4.71658 15.9704 4.44882 16.0602C4.18106 16.1499 3.93825 16.3016 3.74012 16.5028C3.54199 16.7041 3.39412 16.9492 3.30854 17.2183C3.22296 17.4875 3.20208 17.773 3.24758 18.0517C3.29309 18.3304 3.4037 18.5945 3.57044 18.8224C3.73718 19.0503 3.95533 19.2357 4.20718 19.3635C4.45903 19.4912 4.73746 19.5578 5.01987 19.5577L5.01846 19.5586Z"
        fill="#141E46"
      />
    </svg>
  );
};

export const ArrowBottomIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.8623 9.90002L7.6123 9.15002L11.9998 13.575L16.3873 9.15002L17.1373 9.90002L11.9998 15.0375L6.8623 9.90002Z"
        fill="#141E46"
      />
    </svg>
  );
};

export const CursorIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_223_8)">
        <path d="M4 4L11 22L13 13L22 11L4 4Z" fill="#141E46" />
      </g>
      <defs>
        <clipPath id="clip0_223_8">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ZoomInIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9999 10H11.9999V7.00003C11.9999 6.73481 11.8945 6.48046 11.707 6.29292C11.5195 6.10538 11.2651 6.00003 10.9999 6.00003C10.7347 6.00003 10.4803 6.10538 10.2928 6.29292C10.1053 6.48046 9.9999 6.73481 9.9999 7.00003V10H6.9999C6.73469 10 6.48033 10.1054 6.2928 10.2929C6.10526 10.4805 5.9999 10.7348 5.9999 11C5.9999 11.2652 6.10526 11.5196 6.2928 11.7071C6.48033 11.8947 6.73469 12 6.9999 12H9.9999V15C9.9999 15.2652 10.1053 15.5196 10.2928 15.7071C10.4803 15.8947 10.7347 16 10.9999 16C11.2651 16 11.5195 15.8947 11.707 15.7071C11.8945 15.5196 11.9999 15.2652 11.9999 15V12H14.9999C15.2651 12 15.5195 11.8947 15.707 11.7071C15.8945 11.5196 15.9999 11.2652 15.9999 11C15.9999 10.7348 15.8945 10.4805 15.707 10.2929C15.5195 10.1054 15.2651 10 14.9999 10ZM21.7099 20.29L17.9999 16.61C19.44 14.8144 20.1374 12.5353 19.9487 10.2413C19.76 7.94733 18.6996 5.81281 16.9854 4.27667C15.2713 2.74053 13.0337 1.91954 10.7328 1.9825C8.43194 2.04546 6.24263 2.98759 4.61505 4.61517C2.98747 6.24275 2.04534 8.43207 1.98237 10.7329C1.91941 13.0338 2.74041 15.2714 4.27655 16.9855C5.81269 18.6997 7.94721 19.7601 10.2412 19.9488C12.5352 20.1375 14.8143 19.4401 16.6099 18L20.2899 21.68C20.3829 21.7738 20.4935 21.8481 20.6153 21.8989C20.7372 21.9497 20.8679 21.9758 20.9999 21.9758C21.1319 21.9758 21.2626 21.9497 21.3845 21.8989C21.5063 21.8481 21.6169 21.7738 21.7099 21.68C21.8901 21.4936 21.9909 21.2444 21.9909 20.985C21.9909 20.7257 21.8901 20.4765 21.7099 20.29ZM10.9999 18C9.61544 18 8.26206 17.5895 7.11091 16.8203C5.95977 16.0511 5.06256 14.9579 4.53275 13.6788C4.00293 12.3997 3.86431 10.9923 4.13441 9.63439C4.4045 8.27653 5.07119 7.02925 6.05016 6.05028C7.02912 5.07131 8.27641 4.40463 9.63427 4.13453C10.9921 3.86443 12.3996 4.00306 13.6787 4.53287C14.9578 5.06268 16.051 5.95989 16.8202 7.11103C17.5894 8.26218 17.9999 9.61556 17.9999 11C17.9999 12.8565 17.2624 14.637 15.9497 15.9498C14.6369 17.2625 12.8564 18 10.9999 18Z"
        fill="black"
      />
    </svg>
  );
};

export const ZoomOutIcon = ({ fill = 'black' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7099 20.29L17.9999 16.61C19.44 14.8144 20.1374 12.5353 19.9487 10.2413C19.76 7.94733 18.6996 5.81281 16.9854 4.27667C15.2713 2.74053 13.0337 1.91954 10.7328 1.9825C8.43194 2.04546 6.24263 2.98759 4.61505 4.61517C2.98747 6.24275 2.04534 8.43207 1.98237 10.7329C1.91941 13.0338 2.74041 15.2714 4.27655 16.9855C5.81269 18.6997 7.94721 19.7601 10.2412 19.9488C12.5352 20.1375 14.8143 19.4401 16.6099 18L20.2899 21.68C20.3829 21.7738 20.4935 21.8481 20.6153 21.8989C20.7372 21.9497 20.8679 21.9758 20.9999 21.9758C21.1319 21.9758 21.2626 21.9497 21.3845 21.8989C21.5063 21.8481 21.6169 21.7738 21.7099 21.68C21.8901 21.4936 21.9909 21.2444 21.9909 20.985C21.9909 20.7257 21.8901 20.4765 21.7099 20.29ZM10.9999 18C9.61544 18 8.26206 17.5895 7.11091 16.8203C5.95977 16.0511 5.06256 14.9579 4.53275 13.6788C4.00293 12.3997 3.86431 10.9923 4.13441 9.63439C4.4045 8.27653 5.07119 7.02925 6.05016 6.05028C7.02912 5.07131 8.27641 4.40463 9.63427 4.13453C10.9921 3.86443 12.3996 4.00306 13.6787 4.53287C14.9578 5.06268 16.051 5.95989 16.8202 7.11103C17.5894 8.26218 17.9999 9.61556 17.9999 11C17.9999 12.8565 17.2624 14.637 15.9497 15.9498C14.6369 17.2625 12.8564 18 10.9999 18ZM14.9999 10H6.9999C6.73469 10 6.48033 10.1054 6.2928 10.2929C6.10526 10.4805 5.9999 10.7348 5.9999 11C5.9999 11.2652 6.10526 11.5196 6.2928 11.7071C6.48033 11.8947 6.73469 12 6.9999 12H14.9999C15.2651 12 15.5195 11.8947 15.707 11.7071C15.8945 11.5196 15.9999 11.2652 15.9999 11C15.9999 10.7348 15.8945 10.4805 15.707 10.2929C15.5195 10.1054 15.2651 10 14.9999 10Z"
        fill={fill}
      />
    </svg>
  );
};

export const MoveIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M5 9l-3 3 3 3" />
    <path d="M9 5l3-3 3 3" />
    <path d="M15 19l3-3 3 3" />
    <path d="M19 9l3 3-3 3" />
    <path d="M2 12h20" />
    <path d="M12 2v20" />
  </svg>
);

export const LineWeightIcon = ({ fill = 'black' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_237_27)">
        <path
          d="M4 9H20C20.55 9 21 8.55 21 8C21 7.45 20.55 7 20 7H4C3.45 7 3 7.45 3 8C3 8.55 3.45 9 4 9ZM4 14H20C20.55 14 21 13.55 21 13V12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12V13C3 13.55 3.45 14 4 14ZM4 20H20C20.55 20 21 19.55 21 19V17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17V19C3 19.55 3.45 20 4 20ZM3.5 5H20.5C20.78 5 21 4.78 21 4.5C21 4.22 20.78 4 20.5 4H3.5C3.22 4 3 4.22 3 4.5C3 4.78 3.22 5 3.5 5Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_237_27">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 -1 24 24)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NextArrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.707 12.707C22.8945 12.5195 22.9998 12.2652 22.9998 12C22.9998 11.7349 22.8945 11.4806 22.707 11.293L17.707 6.29304C17.5184 6.11088 17.2658 6.01009 17.0036 6.01237C16.7414 6.01465 16.4906 6.11981 16.3052 6.30522C16.1198 6.49063 16.0146 6.74144 16.0123 7.00364C16.01 7.26584 16.1108 7.51844 16.293 7.70704L19.586 11H2C1.73478 11 1.48043 11.1054 1.29289 11.2929C1.10536 11.4805 1 11.7348 1 12C1 12.2653 1.10536 12.5196 1.29289 12.7071C1.48043 12.8947 1.73478 13 2 13H19.586L16.293 16.293C16.1108 16.4816 16.01 16.7342 16.0123 16.9964C16.0146 17.2586 16.1198 17.5095 16.3052 17.6949C16.4906 17.8803 16.7414 17.9854 17.0036 17.9877C17.2658 17.99 17.5184 17.8892 17.707 17.707L22.707 12.707Z"
        fill="black"
      />
    </svg>
  );
};
export const BidirectionalArrowIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.26837 13.0555C1.09653 12.9081 1 12.7083 1 12.5C1 12.2917 1.09653 12.0919 1.26837 11.9445L6.76801 7.23063C6.85311 7.15759 6.95417 7.09962 7.0654 7.06005C7.17664 7.02048 7.29588 7.00007 7.41632 7C7.53676 6.99993 7.65603 7.02019 7.76733 7.05963C7.87864 7.09906 7.97979 7.1569 8.06501 7.22985C8.15023 7.30279 8.21786 7.38941 8.26402 7.48475C8.31019 7.5801 8.334 7.6823 8.33408 7.78553C8.33417 7.88876 8.31053 7.991 8.26452 8.0864C8.21851 8.1818 8.15103 8.2685 8.06593 8.34155L4.13002 11.7151H19.87L15.9341 8.34155C15.7622 8.19402 15.6657 7.99402 15.6659 7.78553C15.666 7.6823 15.6898 7.5801 15.736 7.48475C15.7821 7.38941 15.8498 7.30279 15.935 7.22985C16.0202 7.1569 16.1214 7.09906 16.2327 7.05963C16.344 7.02019 16.4632 6.99993 16.5837 7C16.8269 7.00015 17.0601 7.08311 17.232 7.23063L22.7316 11.9445C22.9035 12.0919 23 12.2917 23 12.5C23 12.7083 22.9035 12.9081 22.7316 13.0555L17.232 17.7694C17.0601 17.9169 16.8269 17.9999 16.5837 18C16.3404 18.0001 16.1071 17.9175 15.935 17.7702C15.7629 17.6228 15.6661 17.4229 15.6659 17.2145C15.6657 17.006 15.7622 16.806 15.9341 16.6585L19.87 13.2864H4.13002L8.06593 16.6585C8.2378 16.806 8.33426 17.006 8.33408 17.2145C8.33391 17.4229 8.23712 17.6228 8.06501 17.7702C7.89289 17.9175 7.65955 18.0001 7.41632 18C7.17309 17.9999 6.93988 17.9169 6.76801 17.7694L1.26837 13.0555Z"
        fill="black"
      />
    </svg>
  );
};

export const GridsIcon20 = ({ fill = '#141E46' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 22.875V1.125C24 0.50475 23.479 0 22.8387 0H1.16129C0.521032 0 0 0.50475 0 1.125V22.875C0 23.4953 0.521032 24 1.16129 24H22.8387C23.479 24 24 23.4953 24 22.875ZM0.774194 22.875V1.125C0.774194 1.02554 0.814977 0.930161 0.887572 0.859835C0.960166 0.789509 1.05863 0.75 1.16129 0.75H22.8387C22.9414 0.75 23.0398 0.789509 23.1124 0.859835C23.185 0.930161 23.2258 1.02554 23.2258 1.125V22.875C23.2258 22.9745 23.185 23.0698 23.1124 23.1402C23.0398 23.2105 22.9414 23.25 22.8387 23.25H1.16129C1.05863 23.25 0.960166 23.2105 0.887572 23.1402C0.814977 23.0698 0.774194 22.9745 0.774194 22.875Z"
        fill={fill}
      />
      <rect x="2" y="14" width="20" height="1" rx="0.5" fill={fill} />
      <rect
        x="4"
        y="22"
        width="20"
        height="1"
        rx="0.5"
        transform="rotate(-90 4 22)"
        fill={fill}
      />
      <rect
        x="19"
        y="22"
        width="20"
        height="1"
        rx="0.5"
        transform="rotate(-90 19 22)"
        fill={fill}
      />
      <rect
        x="14"
        y="22"
        width="20"
        height="1"
        rx="0.5"
        transform="rotate(-90 14 22)"
        fill={fill}
      />
      <rect
        x="9"
        y="22"
        width="20"
        height="1"
        rx="0.5"
        transform="rotate(-90 9 22)"
        fill={fill}
      />
      <rect x="2" y="4" width="20" height="1" rx="0.5" fill={fill} />
      <rect x="2" y="9" width="20" height="1" rx="0.5" fill={fill} />
      <rect x="2" y="19" width="20" height="1" rx="0.5" fill={fill} />
    </svg>
  );
};

export const GridsIcon50 = ({ fill = '#141E46' }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="11" width="19" height="1" rx="0.5" fill={fill} />
      <rect
        x="5"
        y="21"
        width="19"
        height="1"
        rx="0.5"
        transform="rotate(-90 5 21)"
        fill={fill}
      />
      <rect
        x="11"
        y="21"
        width="19"
        height="1"
        rx="0.5"
        transform="rotate(-90 11 21)"
        fill={fill}
      />
      <rect
        x="17"
        y="21"
        width="19"
        height="1"
        rx="0.5"
        transform="rotate(-90 17 21)"
        fill={fill}
      />
      <rect x="2" y="5" width="19" height="1" rx="0.5" fill={fill} />
      <rect x="2" y="17" width="19" height="1" rx="0.5" fill={fill} />
      <path
        d="M23 21.9219V1.07812C23 0.483719 22.5007 0 21.8871 0H1.1129C0.499323 0 0 0.483719 0 1.07812V21.9219C0 22.5163 0.499323 23 1.1129 23H21.8871C22.5007 23 23 22.5163 23 21.9219ZM0.741935 21.9219V1.07812C0.741935 0.982813 0.781019 0.891404 0.850589 0.824008C0.920159 0.756613 1.01452 0.71875 1.1129 0.71875H21.8871C21.9855 0.71875 22.0798 0.756613 22.1494 0.824008C22.219 0.891404 22.2581 0.982813 22.2581 1.07812V21.9219C22.2581 22.0172 22.219 22.1086 22.1494 22.176C22.0798 22.2434 21.9855 22.2812 21.8871 22.2812H1.1129C1.01452 22.2812 0.920159 22.2434 0.850589 22.176C0.781019 22.1086 0.741935 22.0172 0.741935 21.9219Z"
        fill={fill}
      />
    </svg>
  );
};

export const GridsIcon80 = ({ fill = '#141E46' }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 21.9219V1.07812C23 0.483719 22.5007 0 21.8871 0H1.1129C0.499323 0 0 0.483719 0 1.07812V21.9219C0 22.5163 0.499323 23 1.1129 23H21.8871C22.5007 23 23 22.5163 23 21.9219ZM0.741935 21.9219V1.07812C0.741935 0.982813 0.781019 0.891404 0.850589 0.824008C0.920159 0.756613 1.01452 0.71875 1.1129 0.71875H21.8871C21.9855 0.71875 22.0798 0.756613 22.1494 0.824008C22.219 0.891404 22.2581 0.982813 22.2581 1.07812V21.9219C22.2581 22.0172 22.219 22.1086 22.1494 22.176C22.0798 22.2434 21.9855 22.2812 21.8871 22.2812H1.1129C1.01452 22.2812 0.920159 22.2434 0.850589 22.176C0.781019 22.1086 0.741935 22.0172 0.741935 21.9219Z"
        fill={fill}
      />
      <rect
        x="4"
        y="21"
        width="19"
        height="1"
        rx="0.5"
        transform="rotate(-90 4 21)"
        fill={fill}
      />
      <rect
        x="18"
        y="21"
        width="19"
        height="1"
        rx="0.5"
        transform="rotate(-90 18 21)"
        fill={fill}
      />
      <rect
        x="11"
        y="21"
        width="19"
        height="1"
        rx="0.5"
        transform="rotate(-90 11 21)"
        fill={fill}
      />
      <rect x="2" y="4" width="19" height="1" rx="0.5" fill={fill} />
      <rect x="2" y="11" width="19" height="1" rx="0.5" fill={fill} />
      <rect x="2" y="18" width="19" height="1" rx="0.5" fill={fill} />
    </svg>
  );
};

export const GridsIcon100 = ({ fill = '#141E46' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 22.875V1.125C24 0.50475 23.479 0 22.8387 0H1.16129C0.521032 0 0 0.50475 0 1.125V22.875C0 23.4953 0.521032 24 1.16129 24H22.8387C23.479 24 24 23.4953 24 22.875ZM0.774194 22.875V1.125C0.774194 1.02554 0.814977 0.930161 0.887572 0.859835C0.960166 0.789509 1.05863 0.75 1.16129 0.75H22.8387C22.9414 0.75 23.0398 0.789509 23.1124 0.859835C23.185 0.930161 23.2258 1.02554 23.2258 1.125V22.875C23.2258 22.9745 23.185 23.0698 23.1124 23.1402C23.0398 23.2105 22.9414 23.25 22.8387 23.25H1.16129C1.05863 23.25 0.960166 23.2105 0.887572 23.1402C0.814977 23.0698 0.774194 22.9745 0.774194 22.875Z"
        fill={fill}
      />
      <rect
        x="12"
        y="22"
        width="20"
        height="1"
        rx="0.5"
        transform="rotate(-90 12 22)"
        fill={fill}
      />
      <rect
        x="20"
        y="22"
        width="20"
        height="1"
        rx="0.5"
        transform="rotate(-90 20 22)"
        fill={fill}
      />
      <rect
        x="3"
        y="22"
        width="20"
        height="1"
        rx="0.5"
        transform="rotate(-90 3 22)"
        fill={fill}
      />
      <rect x="2" y="11" width="20" height="1" rx="0.5" fill={fill} />
      <rect x="2" y="20" width="20" height="1" rx="0.5" fill={fill} />
      <rect x="2" y="3" width="20" height="1" rx="0.5" fill={fill} />
    </svg>
  );
};

export const EditIcon = ({ fill = '#141E46' }) => {
  return (
    <svg
      height="20"
      viewBox="0 0 496.05588 496"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
    >
      <path d="m462.574219 33.464844c-15.664063-15.671875-34.183594-26.777344-52.160157-31.265625-19.421874-4.832031-36.0625-1.542969-46.917968 9.296875l-.007813-.007813-298.25 295.992188-63.054687 149.734375c-1.449219 3.457031-2.183594 7.105468-2.183594 10.855468 0 15.425782 12.542969 27.96875 27.96875 27.96875 3.75 0 7.398438-.734374 10.847656-2.183593l149.742188-63.054688 295.992187-298.25c21.601563-21.65625 11.953125-65.167969-21.976562-99.085937zm-326.535157 326.613281-.046874-56.039063h-44.578126l52.832032-52.429687 12.441406 12.429687c5.160156 5.160157 12.015625 8 19.3125 8s14.160156-2.839843 19.3125-8l116.6875-116.6875c5.160156-5.160156 8-12.015624 8-19.3125 0-7.296874-2.839844-14.160156-8-19.3125l-11.847656-11.847656 51.953125-51.550781c1.152343 20.617187 12.726562 44.703125 33.320312 65.289063 20.613281 20.613281 44.71875 32.125 65.351563 33.253906l-258.777344 260.753906v-44.59375zm164.648438-224.039063-4.6875 4.6875-19.9375-19.933593 12.738281-12.640625 11.886719 11.886718c2.136719 2.144532 3.3125 4.976563 3.3125 8 0 3.023438-1.175781 5.855469-3.3125 8zm-16 16-12.6875 12.6875-20.023438-20.023437 12.734376-12.640625zm-24 24-12.6875 12.6875-20.121094-20.117187 12.738282-12.640625zm-24 24-12.6875 12.6875-20.207031-20.207031 12.734375-12.640625zm-24 24-12.6875 12.6875-20.304688-20.304687 12.738282-12.636719zm-24 24-4.6875 4.6875c-4.28125 4.265626-11.71875 4.265626-16 0l-12.390625-12.390624 12.734375-12.640626zm205.121094-232.046874c16.917968 0 39.160156 10.488281 57.464844 28.785156 26.671874 26.679687 36.726562 61.703125 21.949218 76.488281-14.78125 14.765625-49.808594 4.726563-76.488281-21.953125s-36.726563-61.695312-21.949219-76.480469c4.640625-4.640625 11.269532-6.839843 19.023438-6.839843zm-316.496094 304.046874h42.695312l.046876 56.054688 55.945312-.046875v42.679687l-85.847656 36.144532-48.984375-48.984375zm-44.695312 159.066407c-1.472657.621093-3.042969.933593-4.648438.933593-6.601562 0-11.96875-5.367187-11.96875-11.96875 0-1.605468.3125-3.167968.9375-4.648437l17.519531-41.605469 39.765625 39.765625zm0 0" />
      <path d="m336.332031 202.425781 15.867188-16 11.359375 11.269531-15.867188 16zm0 0" />
      <path d="m217.246094 322.441406 103.179687-104.03125 11.359375 11.269532-103.179687 104.027343zm0 0" />
      <path d="m433.238281 104.054688c6.304688 0 12.082031-2.085938 16.386719-6.390626 10.632812-10.632812 7.710938-30.214843-6.65625-44.59375-14.382812-14.367187-33.960938-17.285156-44.59375-6.65625-10.632812 10.632813-7.710938 30.21875 6.65625 44.59375 8.554688 8.542969 18.953125 13.046876 28.207031 13.046876zm-23.550781-46.328126c1.136719-1.136718 2.914062-1.703124 5.074219-1.703124 4.726562 0 11.269531 2.746093 16.894531 8.359374 8.183594 8.191407 10.265625 18.359376 6.65625 21.96875-3.617188 3.617188-13.777344 1.519532-21.96875-6.65625-8.183594-8.191406-10.265625-18.359374-6.65625-21.96875zm0 0" />
    </svg>
  );
};

export const LinkIcon = ({ fill = '#141E46' }) => {
  return (
    <svg
      id="Layer_1"
      height="24"
      viewBox="0 0 1024 1024"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      dataName="Layer 1"
      fill={fill}
    >
      <path d="M166.4 512c0-72.96 59.306667-132.266667 132.266667-132.266667h170.666666V298.666667h-170.666666C180.906667 298.666667 85.333333 394.24 85.333333 512s95.573333 213.333333 213.333334 213.333333h170.666666v-81.066666h-170.666666c-72.96 0-132.266667-59.306667-132.266667-132.266667z m174.933333 42.666667h341.333334v-85.333334H341.333333v85.333334z m384-256h-170.666666v81.066666h170.666666c72.96 0 132.266667 59.306667 132.266667 132.266667s-59.306667 132.266667-132.266667 132.266667h-170.666666V725.333333h170.666666c117.76 0 213.333333-95.573333 213.333334-213.333333s-95.573333-213.333333-213.333334-213.333333z" />{' '}
    </svg>
  );
};

export const DuplicateIcon = ({ fill = '#141E46' }) => {
  return (
    <svg
      id="Layer_1"
      height="24"
      viewBox="0 0 32 32"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      dataName="Layer 1"
      fill={fill}
    >
      <path d="m20 29h-14a3 3 0 0 1 -3-3v-14a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3zm-14-18a1 1 0 0 0 -1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-14a1 1 0 0 0 -1-1z" />
      <path d="m10 8a1 1 0 0 1 -1-1v-1a3 3 0 0 1 3-3h1a1 1 0 0 1 0 2h-1a1 1 0 0 0 -1 1v1a1 1 0 0 1 -1 1z" />
      <path d="m26 23h-1a1 1 0 0 1 0-2h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 2 0v1a3 3 0 0 1 -3 3z" />
      <path d="m28 8a1 1 0 0 1 -1-1v-1a1 1 0 0 0 -1-1h-1a1 1 0 0 1 0-2h1a3 3 0 0 1 3 3v1a1 1 0 0 1 -1 1z" />
      <path d="m28 16a1 1 0 0 1 -1-1v-4a1 1 0 0 1 2 0v4a1 1 0 0 1 -1 1z" />
      <path d="m21 5h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z" />
      <path d="m16 20h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2z" />
      <path d="m13 23a1 1 0 0 1 -1-1v-6a1 1 0 0 1 2 0v6a1 1 0 0 1 -1 1z" />
    </svg>
  );
};

export const LayoutUpIcon = ({ fill = '#141E46' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M12.75 5.82v8.43a.75.75 0 1 1-1.5 0V5.81L8.99 8.07A.75.75 0 1 1 7.93 7l2.83-2.83a1.75 1.75 0 0 1 2.47 0L16.06 7A.75.75 0 0 1 15 8.07l-2.25-2.25zM15 10.48l6.18 3.04a1 1 0 0 1 0 1.79l-7.86 3.86a3 3 0 0 1-2.64 0l-7.86-3.86a1 1 0 0 1 0-1.8L9 10.49v1.67L4.4 14.4l6.94 3.42c.42.2.9.2 1.32 0l6.94-3.42-4.6-2.26v-1.67z"
      ></path>
    </svg>
  );
};

export const LayoutDownIcon = ({ fill = '#141E46' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M12.75 18.12V9.75a.75.75 0 1 0-1.5 0v8.37l-2.26-2.25a.75.75 0 0 0-1.06 1.06l2.83 2.82c.68.69 1.79.69 2.47 0l2.83-2.82A.75.75 0 0 0 15 15.87l-2.25 2.25zM15 11.85v1.67l6.18-3.04a1 1 0 0 0 0-1.79l-7.86-3.86a3 3 0 0 0-2.64 0L2.82 8.69a1 1 0 0 0 0 1.8L9 13.51v-1.67L4.4 9.6l6.94-3.42c.42-.2.9-.2 1.32 0L19.6 9.6 15 11.85z"
      ></path>
    </svg>
  );
};

export const FolderIcon = ({ fill = '#376cfb', size = 24 }) => {
  return (
    <svg
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Folder">
        <path
          d="m12.8945 6.5527-2-4a1 1 0 0 0 -.8945-.5527h-8a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 .8945-1.4473z"
          fill={fill}
        />
        <path
          d="m22 6h-21v15a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-14a1 1 0 0 0 -1-1z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const PhotosIcon = ({ fill = 'white' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="24"
      height="24"
      x="0"
      y="0"
      viewBox="0 0 58.013 58.013"
    >
      <g>
        <path
          d="M17.575 29.007a8.906 8.906 0 0 1-3.411-2.121l-5.657-5.657a8.869 8.869 0 0 1-.92-1.097l-.001-.001C3.303 20.815 0 24.539 0 29.007c0 4.95 4.05 9 9 9h8c4.95 0 9-4.05 9-9a8.98 8.98 0 0 0-.102-1.278 8.929 8.929 0 0 1-2.417 1.278 9.069 9.069 0 0 0-5.906 0z"
          fill={fill}
          opacity="1"
        ></path>
        <path
          d="M37.888 7.58c-.69-4.277-4.411-7.574-8.875-7.574s-8.185 3.297-8.875 7.574c.383.276.753.576 1.097.92l5.657 5.657a8.894 8.894 0 0 1 2.121 3.411 9.082 9.082 0 0 1 0 5.906 8.922 8.922 0 0 1-1.285 2.429c.421.061.848.104 1.285.104s.864-.042 1.285-.104a8.902 8.902 0 0 0 2.627-.809 9.077 9.077 0 0 0 4.176-4.176 8.902 8.902 0 0 0 .912-3.912v-8c0-.486-.05-.96-.125-1.426z"
          fill={fill}
          opacity="1"
        ></path>
        <path
          d="m36.791 49.513-5.657-5.657a8.894 8.894 0 0 1-2.121-3.411 9.082 9.082 0 0 1 0-5.906 8.922 8.922 0 0 1 1.285-2.429c-.421-.061-.848-.104-1.285-.104s-.864.042-1.285.104a8.902 8.902 0 0 0-2.627.809 9.077 9.077 0 0 0-4.176 4.176 8.902 8.902 0 0 0-.912 3.912v8c0 .486.05.96.125 1.426.69 4.277 4.411 7.574 8.875 7.574s8.185-3.297 8.875-7.574a9.048 9.048 0 0 1-1.097-.92z"
          fill={fill}
          opacity="1"
        ></path>
        <path
          d="M50.439 20.132a8.869 8.869 0 0 1-.92 1.097l-5.657 5.657a8.906 8.906 0 0 1-3.411 2.121 9.082 9.082 0 0 1-5.906 0 8.922 8.922 0 0 1-2.429-1.285 8.934 8.934 0 0 0-.103 1.285c0 .437.042.864.103 1.285.135.929.411 1.811.809 2.627a9.077 9.077 0 0 0 4.176 4.176 8.902 8.902 0 0 0 3.912.912h8c.486 0 .96-.05 1.426-.125 4.277-.69 7.574-4.411 7.574-8.875s-3.297-8.186-7.574-8.875z"
          fill={fill}
          opacity="1"
        ></path>
        <path
          d="M49.519 8.5c-3.156-3.156-8.119-3.456-11.631-.92.075.466.125.94.125 1.426v8a8.902 8.902 0 0 1-.912 3.912 9.077 9.077 0 0 1-4.176 4.176 8.902 8.902 0 0 1-2.627.809c.255.341.527.673.836.982s.641.581.982.836c.752.561 1.571.99 2.429 1.285a9.082 9.082 0 0 0 5.906 0 8.906 8.906 0 0 0 3.411-2.121l5.657-5.657c.344-.344.644-.714.92-1.097 2.537-3.512 2.236-8.474-.92-11.631z"
          fill={fill}
          opacity="1"
        ></path>
        <path
          d="M50.439 37.882c-.466.075-.94.125-1.426.125h-8a8.902 8.902 0 0 1-3.912-.912 9.077 9.077 0 0 1-4.176-4.176 8.902 8.902 0 0 1-.809-2.627c-.341.255-.673.527-.982.836s-.581.641-.836.982a8.894 8.894 0 0 0-1.285 2.429 9.082 9.082 0 0 0 0 5.906 8.906 8.906 0 0 0 2.121 3.411l5.657 5.657c.344.344.714.644 1.097.92 3.512 2.536 8.475 2.236 11.631-.92s3.457-8.119.92-11.631z"
          fill={fill}
          opacity="1"
        ></path>
        <path
          d="M29.013 17.569a8.906 8.906 0 0 0-2.121-3.411L21.235 8.5a8.869 8.869 0 0 0-1.097-.92c-3.512-2.536-8.475-2.236-11.631.92-3.156 3.156-3.456 8.117-.921 11.629A9.032 9.032 0 0 1 9 20.007h8c4.515 0 8.271 3.373 8.898 7.722l.012-.008c.341-.255.673-.527.982-.836s.581-.641.836-.982a8.894 8.894 0 0 0 1.285-2.429 9.079 9.079 0 0 0 0-5.905z"
          fill={fill}
          opacity="1"
        ></path>
        <path
          d="M17 20.007H9a8.913 8.913 0 0 0-1.413.125c.276.383.576.753.92 1.097l5.657 5.657a8.906 8.906 0 0 0 3.411 2.121 9.082 9.082 0 0 1 5.906 0 8.901 8.901 0 0 0 2.417-1.278c-.627-4.349-4.383-7.722-8.898-7.722z"
          fill={fill}
          opacity="1"
        ></path>
        <path
          d="M26.892 31.128a8.973 8.973 0 0 0-.982-.836 8.894 8.894 0 0 0-2.429-1.285 9.082 9.082 0 0 0-5.906 0 8.906 8.906 0 0 0-3.411 2.121l-5.657 5.657a8.869 8.869 0 0 0-.92 1.097c-2.536 3.512-2.236 8.475.92 11.631s8.119 3.456 11.631.92a8.947 8.947 0 0 1-.125-1.426v-8c0-1.402.334-2.726.912-3.912a9.077 9.077 0 0 1 4.176-4.176 8.902 8.902 0 0 1 2.627-.809 8.973 8.973 0 0 0-.836-.982z"
          fill={fill}
          opacity="1"
        ></path>
      </g>
    </svg>
  );
};

export const GalleryIcon = ({ fill = '#376cfb', size = 32 }) => {
  return (
    <svg
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="_2"
        gradientUnits="userSpaceOnUse"
        x1="2.06"
        x2="21.5"
        y1="17.499"
        y2="17.499"
      >
        <stop offset="0" stopColor="#16b0e2" />
        <stop offset="1" stopColor="#6e5af0" />
      </linearGradient>
      <linearGradient
        id="_2-2"
        x1="1.5"
        xlinkHref="#_2"
        y1="11.015"
        y2="11.015"
      />
      <linearGradient
        id="_2-3"
        x1="6.125"
        x2="10.875"
        xlinkHref="#_2"
        y1="8.5"
        y2="8.5"
      />
      <linearGradient
        id="_2-4"
        x1="15.5"
        x2="22.5"
        xlinkHref="#_2"
        y1="5"
        y2="5"
      />
      <g id="_01" data-name="01">
        <path
          d="m21.5 14.4v2.29c0 3.64-2.17 5.81-5.81 5.81h-8.38c-2.55 0-4.39-1.07-5.25-2.97l.11-.08 4.92-3.3a2.221 2.221 0 0 1 2.64.14l.34.28a2.229 2.229 0 0 0 2.82 0l4.16-3.57a2.229 2.229 0 0 1 2.82 0z"
          fill="url(#_2)"
        />
        <path
          d="m21.5 8.277v.033 6.09l-1.63-1.4a2.229 2.229 0 0 0 -2.82 0l-4.16 3.57a2.229 2.229 0 0 1 -2.82 0l-.34-.28a2.221 2.221 0 0 0 -2.64-.14l-4.92 3.3-.11.08a6.723 6.723 0 0 1 -.56-2.84v-8.38c0-3.64 2.17-5.81 5.81-5.81h8.38.033a2.314 2.314 0 0 0 -.223 1.03v2.94a1.866 1.866 0 0 0 2.03 2.03h2.94a2.314 2.314 0 0 0 1.03-.223z"
          fill="url(#_2-2)"
          opacity=".4"
        />
        <path
          d="m10.875 8.5a2.375 2.375 0 1 1 -2.375-2.375 2.377 2.377 0 0 1 2.375 2.375z"
          fill="url(#_2-3)"
        />
        <path
          d="m20.47 1.5h-2.94a1.866 1.866 0 0 0 -2.03 2.03v2.94a1.866 1.866 0 0 0 2.03 2.03h2.94a1.866 1.866 0 0 0 2.03-2.03v-2.94a1.866 1.866 0 0 0 -2.03-2.03zm.94 3.93a.647.647 0 0 1 -.41.18h-1.41l.01 1.39a.632.632 0 0 1 -.19.43.59.59 0 0 1 -.41.17.6.6 0 0 1 -.6-.6v-1.4l-1.4.01a.61.61 0 0 1 -.6-.61.6.6 0 0 1 .6-.6l1.4.01v-1.4a.6.6 0 1 1 1.2 0l-.01 1.39h1.41a.6.6 0 0 1 .6.6.681.681 0 0 1 -.19.43z"
          fill="url(#_2-4)"
        />
      </g>
    </svg>
  );
};

export const EmptyDataIcon = ({ size = 220 }) => {
  return (
    <svg
      clipRule="evenodd"
      fillRule="evenodd"
      height={size}
      strokeLinejoin="round"
      strokeMiterlimit="2"
      viewBox="0 0 64 64"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Exp-1.-O">
        <g fill="#738bab">
          <path d="m27.815 20.643c.803-.319 1.717-.539 2.731-.641.275-.027.475-.272.448-.547-.028-.274-.273-.475-.547-.448-1.115.112-2.119.356-3.001.707-.257.101-.382.392-.28.649.102.256.393.382.649.28z" />
          <path d="m32.996 19.983c1.182.089 2.264.108 3.252.066.276-.011.491-.244.479-.52-.011-.276-.245-.49-.52-.479-.953.04-1.996.021-3.136-.065-.275-.02-.515.186-.536.461-.021.276.186.516.461.537z" />
          <path d="m38.948 19.753c1.166-.219 2.155-.543 2.986-.942.249-.12.354-.419.234-.667-.119-.249-.418-.354-.667-.235-.762.366-1.669.661-2.738.862-.271.051-.45.312-.399.584.051.271.313.449.584.398z" />
          <path d="m43.972 17.422c.896-.865 1.422-1.861 1.659-2.874.063-.269-.105-.538-.373-.601-.269-.063-.538.105-.601.373-.196.841-.636 1.665-1.379 2.382-.199.192-.205.509-.013.707.192.199.508.205.707.013z" />
          <path d="m45.393 11.105c-.397-1.054-1.07-1.949-1.89-2.515-.227-.156-.538-.099-.695.128s-.1.539.128.696c.663.457 1.2 1.189 1.521 2.043.097.258.385.389.644.292.258-.097.389-.386.292-.644z" />
          <path d="m32.365 8.588c.549-2.576 2.737-3.829 4.315-3.838.518-.003.967.119 1.2.431.138.185.18.433.127.737-.047.272.136.531.408.578s.531-.136.578-.408c.108-.625-.028-1.126-.312-1.505-.397-.533-1.125-.838-2.006-.833-1.921.011-4.62 1.494-5.288 4.63-.058.27.114.535.384.593s.536-.115.594-.385z" />
          <path d="m31.391 8.59c.677 3.12 3.366 4.596 5.282 4.608.949.005 1.718-.348 2.094-.959.227-.368.326-.837.22-1.41-.13-.705-.594-1.608-1.565-2.68-.185-.205-.502-.221-.706-.036-.205.186-.221.502-.035.707.676.747 1.077 1.384 1.253 1.919.133.408.13.735-.018.976-.134.217-.374.348-.663.42-.363.09-.798.083-1.257-.014-1.467-.31-3.149-1.537-3.627-3.743-.059-.27-.325-.441-.595-.383-.27.059-.441.325-.383.595z" />
        </g>
        <path
          d="m31.744 9.484h6.695c.552 0 1-.448 1-1s-.448-1-1-1h-6.695c-.552 0-1 .448-1 1s.448 1 1 1z"
          fill="#2d74ff"
        />
        <path
          d="m11.5 48.52v5.609c0 1.104.724 2.077 1.782 2.394 4.018 1.206 15.32 4.597 18 5.4.468.141.968.141 1.436 0 2.68-.803 13.982-4.194 18-5.4 1.058-.317 1.782-1.29 1.782-2.394 0-2.67 0-7.997 0-7.997 0-.276-.224-.5-.5-.5s-.5.224-.5.5v7.997c0 .662-.435 1.246-1.069 1.437-4.018 1.205-15.321 4.596-18 5.4-.281.084-.581.084-.862 0l-18-5.4c-.634-.191-1.069-.775-1.069-1.437v-5.609c0-.276-.224-.5-.5-.5s-.5.224-.5.5z"
          fill="#738bab"
        />
        <path
          d="m10.336 37.19s-2.532 3.754-3.826 5.672c-.263.39-.328.882-.174 1.327.153.445.506.793.954.938l17.995 5.847c.636.206 1.331-.032 1.706-.585 1.341-1.98 5.423-8.002 5.423-8.002.088-.13.11-.294.059-.443s-.169-.265-.319-.313l-20-6.49c-.262-.085-.544.059-.63.322-.085.262.059.544.322.63l19.367 6.284s-5.05 7.451-5.05 7.451c-.125.184-.357.264-.569.195 0 0-17.995-5.847-17.995-5.847-.149-.049-.267-.164-.318-.313-.051-.148-.029-.312.058-.442l3.826-5.672c.155-.229.094-.54-.135-.694-.228-.155-.539-.094-.694.135z"
          fill="#738bab"
        />
        <path
          d="m49.001 36.064-17.155 5.567c-.263.085-.407.367-.322.63.086.262.368.406.63.321l17.155-5.566c.263-.085.407-.368.322-.63-.086-.263-.368-.407-.63-.322z"
          fill="#738bab"
        />
        <path
          d="m33.002 44.476s2.901 4.28 4.007 5.913c.375.553 1.07.791 1.706.585 2.949-.958 14.196-4.613 17.995-5.847.448-.145.801-.493.954-.938.154-.445.089-.937-.174-1.327-1.568-2.325-5.075-7.525-5.075-7.525-.155-.228-.466-.289-.695-.135-.228.155-.289.466-.135.695 0 0 3.508 5.199 5.076 7.524.087.13.109.294.058.442-.051.149-.169.264-.318.313 0 0-17.995 5.847-17.995 5.847-.212.069-.444-.011-.569-.195l-4.007-5.913c-.155-.229-.466-.288-.695-.133-.228.154-.288.466-.133.694z"
          fill="#738bab"
        />
        <path
          d="m15.192 35.104 16.963-5.522c.149-.049.267-.165.318-.314s.029-.313-.06-.443c0 0-3.592-5.283-4.841-7.12-.375-.551-1.069-.789-1.704-.583l-17.996 5.847c-.448.146-.801.493-.955.939-.153.445-.088.936.175 1.327 1.444 2.141 4.493 6.662 4.493 6.662.155.228.466.289.695.134.228-.154.289-.465.135-.694 0 0-3.05-4.52-4.494-6.661-.088-.131-.109-.294-.058-.443.051-.148.169-.264.318-.313 0 0 17.996-5.847 17.996-5.847.212-.069.443.011.568.194 0 0 4.467 6.57 4.467 6.57s-16.329 5.316-16.329 5.316c-.263.085-.406.368-.321.63.086.262.368.406.63.321z"
          fill="#738bab"
        />
        <path
          d="m31.845 29.582 20 6.51c.212.069.445-.01.57-.195 0 0 3.049-4.521 4.493-6.662.263-.391.328-.882.175-1.327-.154-.446-.507-.793-.955-.939l-17.996-5.847c-.635-.206-1.329.032-1.704.583l-3.498 5.144c-.155.229-.096.54.132.695.229.155.54.096.695-.132l3.498-5.145c.125-.183.356-.263.568-.194 0 0 17.996 5.847 17.996 5.847.149.049.267.165.318.313.051.149.03.312-.058.443l-4.283 6.349s-19.641-6.394-19.641-6.394c-.263-.086-.545.058-.63.321-.086.262.058.544.32.63z"
          fill="#738bab"
        />
        <path
          d="m47.147 35.615-15.147 4.914s-15.147-4.914-15.147-4.914 15.147-4.931 15.147-4.931z"
          fill="#2d74ff"
        />
        <path
          d="m26.998 29.06c-.269-.379-.5-.76-.694-1.141-.125-.246-.426-.344-.672-.218-.246.125-.344.426-.219.672.215.423.471.846.77 1.267.16.225.472.277.697.118.225-.16.278-.473.118-.698z"
          fill="#738bab"
        />
        <path
          d="m25.611 25.839c-.09-.57-.094-1.127-.015-1.661.04-.273-.149-.527-.422-.567s-.527.149-.568.422c-.092.63-.089 1.288.017 1.961.043.273.299.459.572.416.272-.043.459-.299.416-.571z"
          fill="#738bab"
        />
      </g>
    </svg>
  );
};

export const ImportIcon = () => {
  return (
    <svg
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_87" data-name="Layer 87">
        <path
          d="m13 5v-3.89a2.9 2.9 0 0 1 1.33.77l2.8 2.84a3 3 0 0 1 .75 1.28h-3.88a1 1 0 0 1 -1-1zm8.72 13.37-2-2.07a1 1 0 0 0 -1.72.7v1h-3a1 1 0 0 0 0 2h3v1a1 1 0 0 0 .61.92 1.09 1.09 0 0 0 .39.08 1 1 0 0 0 .7-.28l2-1.94a1 1 0 0 0 .3-.7 1 1 0 0 0 -.28-.71zm-4.72-4.37a1 1 0 0 0 1-1v-5h-4a3 3 0 0 1 -3-3v-4h-6a3 3 0 0 0 -3 3v16a3 3 0 0 0 3 3h6.81.2a.6.6 0 0 0 .19-.06l.12-.06a1 1 0 0 0 .46-.64.83.83 0 0 0 0-.22.82.82 0 0 0 0-.26.77.77 0 0 0 -.1-.25 4.88 4.88 0 0 1 -.68-2.51 5 5 0 0 1 5-5z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const CheckIcon = () => {
  return (
    <svg
      clipRule="evenodd"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(-144 -48)">
        <g id="Icon">
          <g transform="matrix(1.023 0 0 1.023 -298.093 -394.093)">
            <circle cx="455.5" cy="455.5" fill="#80c783" r="21.5" />
          </g>
          <g transform="translate(-288 -382)">
            <path
              d="m447.109 452.336c-.81-.541-1.892-.418-2.562.29-.669.707-.732 1.795-.147 2.574l6 8c.362.482.922.776 1.525.799.602.022 1.183-.228 1.58-.682l14-16c.691-.789.654-1.978-.084-2.724s-1.926-.794-2.723-.112l-12.849 11.014s-4.74-3.159-4.74-3.159z"
              fill="#fafafa"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
